export const jobTabData = {
	layout: {
		_qf__employee: {
			childKeys: [],
			key: '_qf__employee',
			type: 'HiddenInput',
		},
		field_3: {
			childKeys: [],
			key: 'field_3',
			type: 'DateField',
		},
		'qfauto-2': {
			childKeys: ['field_3'],
			key: 'qfauto-2',
			settings: {
				id: 'qfauto-2',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_1037: {
			childKeys: [],
			key: 'field_1037',
			type: 'Select',
		},
		field_157: {
			childKeys: [],
			key: 'field_157',
			type: 'Select',
		},
		'qfauto-3': {
			childKeys: ['field_1037', 'field_157'],
			key: 'qfauto-3',
			settings: {
				id: 'qfauto-3',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4001: {
			childKeys: [],
			key: 'field_4001',
			type: 'CheckboxGroup',
		},
		'qfauto-4': {
			childKeys: ['field_4001'],
			key: 'qfauto-4',
			settings: {
				id: 'qfauto-4',
				name: 'field_4001',
				label: 'Veteran Status',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'CheckboxGroup',
		},
		'qfauto-5': {
			childKeys: ['field_4001'],
			key: 'qfauto-5',
			settings: {
				id: 'qfauto-5',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'field_4292[0]': {
			childKeys: [],
			key: 'field_4292[0]',
			type: 'CurrencyField',
		},
		'qfauto-6': {
			childKeys: ['field_4292[0]'],
			key: 'qfauto-6',
			settings: {
				id: 'qfauto-6',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4356: {
			childKeys: [],
			key: 'field_4356',
			type: 'Select',
		},
		'qfauto-7': {
			childKeys: ['field_4356'],
			key: 'qfauto-7',
			settings: {
				id: 'qfauto-7',
				maxLength: '255',
				label: '',
				validation: {
					maxLength: 255,
				},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-8': {
			childKeys: ['qfauto-7'],
			key: 'qfauto-8',
			settings: {
				id: 'qfauto-8',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4357: {
			childKeys: [],
			key: 'field_4357',
			type: 'TextField',
		},
		'qfauto-9': {
			childKeys: ['field_4357'],
			key: 'qfauto-9',
			settings: {
				id: 'qfauto-9',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4358: {
			childKeys: [],
			key: 'field_4358',
			type: 'TextField',
		},
		'qfauto-10': {
			childKeys: ['field_4358'],
			key: 'qfauto-10',
			settings: {
				id: 'qfauto-10',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4359: {
			childKeys: [],
			key: 'field_4359',
			type: 'TextField',
		},
		'qfauto-11': {
			childKeys: ['field_4359'],
			key: 'qfauto-11',
			settings: {
				id: 'qfauto-11',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4360: {
			childKeys: [],
			key: 'field_4360',
			type: 'CheckboxGroup',
		},
		'qfauto-12': {
			childKeys: ['field_4360'],
			key: 'qfauto-12',
			settings: {
				id: 'qfauto-12',
				maxLength: '255',
				name: 'field_4360',
				label: 'Custom multi select',
				validation: {
					maxLength: 255,
				},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'CheckboxGroup',
		},
		'qfauto-13': {
			childKeys: ['field_4360'],
			key: 'qfauto-13',
			settings: {
				id: 'qfauto-13',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4361: {
			childKeys: [],
			key: 'field_4361',
			type: 'Textarea',
		},
		'qfauto-14': {
			childKeys: ['field_4361'],
			key: 'qfauto-14',
			settings: {
				id: 'qfauto-14',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4362: {
			childKeys: [],
			key: 'field_4362',
			type: 'Select',
		},
		'qfauto-15': {
			childKeys: ['field_4362'],
			key: 'qfauto-15',
			settings: {
				id: 'qfauto-15',
				validation: {},
				label: '',
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'field_4363[0]': {
			childKeys: [],
			key: 'field_4363[0]',
			type: 'CurrencyField',
		},
		'qfauto-16': {
			childKeys: ['field_4363[0]'],
			key: 'qfauto-16',
			settings: {
				id: 'qfauto-16',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-1': {
			childKeys: [
				'qfauto-2',
				'qfauto-3',
				'qfauto-5',
				'qfauto-6',
				'qfauto-8',
				'qfauto-9',
				'qfauto-10',
				'qfauto-11',
				'qfauto-13',
				'qfauto-14',
				'qfauto-15',
				'qfauto-16',
			],
			key: 'qfauto-1',
			settings: {
				id: 'qfauto-1',
				validation: {},
				FieldSetType: 'job',
				defaultValue: '',
				className: 'legend-icon-job ',
				elementSettings: [],
			},
			type: 'Section',
		},
		'qfauto-18': {
			childKeys: [],
			key: 'qfauto-18',
			type: 'Text',
			settings: {
				id: 'qfauto-18',
				'data-type-of-field': 'custom',
				maxLength: '255',
				value: 'This is information',
				'data-lpignore': 'true',
				label: 'Custom Information',
				validation: {
					maxLength: 255,
				},
				note: 'This is information',
				defaultValue: '',
				className: '  ',
				elementSettings: {
					isCustomField: true,
				},
			},
		},
		'qfauto-19': {
			childKeys: ['qfauto-18'],
			key: 'qfauto-19',
			settings: {
				id: 'qfauto-19',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_1356: {
			childKeys: [],
			key: 'field_1356',
			type: 'TextField',
		},
		'qfauto-20': {
			childKeys: ['field_1356'],
			key: 'qfauto-20',
			settings: {
				id: 'qfauto-20',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4194: {
			childKeys: [],
			key: 'field_4194',
			type: 'DateField',
		},
		'qfauto-21': {
			childKeys: ['field_4194'],
			key: 'qfauto-21',
			settings: {
				id: 'qfauto-21',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4195: {
			childKeys: [],
			key: 'field_4195',
			type: 'DateField',
		},
		'qfauto-22': {
			childKeys: ['field_4195'],
			key: 'qfauto-22',
			settings: {
				id: 'qfauto-22',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4201: {
			childKeys: [],
			key: 'field_4201',
			type: 'Select',
		},
		'qfauto-23': {
			childKeys: ['field_4201'],
			key: 'qfauto-23',
			settings: {
				id: 'qfauto-23',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4202: {
			childKeys: [],
			key: 'field_4202',
			type: 'Select',
		},
		'qfauto-24': {
			childKeys: ['field_4202'],
			key: 'qfauto-24',
			settings: {
				id: 'qfauto-24',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4077: {
			childKeys: [],
			key: 'field_4077',
			type: 'Select',
		},
		'qfauto-25': {
			childKeys: ['field_4077'],
			key: 'qfauto-25',
			settings: {
				id: 'qfauto-25',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4078: {
			childKeys: [],
			key: 'field_4078',
			type: 'TextField',
		},
		'qfauto-26': {
			childKeys: ['field_4078'],
			key: 'qfauto-26',
			settings: {
				id: 'qfauto-26',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4197: {
			childKeys: [],
			key: 'field_4197',
			type: 'Select',
		},
		'qfauto-27': {
			childKeys: ['field_4197'],
			key: 'qfauto-27',
			settings: {
				id: 'qfauto-27',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_34: {
			childKeys: [],
			key: 'field_34',
			type: 'SensitiveTextField',
		},
		'qfauto-28': {
			childKeys: ['field_34'],
			key: 'qfauto-28',
			settings: {
				id: 'qfauto-28',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4093: {
			childKeys: [],
			key: 'field_4093',
			type: 'Checkbox',
		},
		'qfauto-29': {
			childKeys: ['field_4093'],
			key: 'qfauto-29',
			settings: {
				id: 'qfauto-29',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_36: {
			childKeys: [],
			key: 'field_36',
			type: 'DateField',
		},
		'qfauto-30': {
			childKeys: ['field_36'],
			key: 'qfauto-30',
			settings: {
				id: 'qfauto-30',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_38: {
			childKeys: [],
			key: 'field_38',
			type: 'TextField',
		},
		'qfauto-31': {
			childKeys: ['field_38'],
			key: 'qfauto-31',
			settings: {
				id: 'qfauto-31',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_35: {
			childKeys: [],
			key: 'field_35',
			type: 'Select',
		},
		'qfauto-32': {
			childKeys: ['field_35'],
			key: 'qfauto-32',
			settings: {
				id: 'qfauto-32',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_37: {
			childKeys: [],
			key: 'field_37',
			type: 'Select',
		},
		'qfauto-33': {
			childKeys: ['field_37'],
			key: 'qfauto-33',
			settings: {
				id: 'qfauto-33',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4289: {
			childKeys: [],
			key: 'field_4289',
			type: 'Checkbox',
		},
		'qfauto-34': {
			childKeys: ['field_4289'],
			key: 'qfauto-34',
			settings: {
				id: 'qfauto-34',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4180: {
			childKeys: [],
			key: 'field_4180',
			type: 'Select',
		},
		'qfauto-35': {
			childKeys: ['field_4180'],
			key: 'qfauto-35',
			settings: {
				id: 'qfauto-35',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4079: {
			childKeys: [],
			key: 'field_4079',
			type: 'TextField',
		},
		'qfauto-36': {
			childKeys: ['field_4079'],
			key: 'qfauto-36',
			settings: {
				id: 'qfauto-36',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4196: {
			childKeys: [],
			key: 'field_4196',
			type: 'TextField',
		},
		'qfauto-37': {
			childKeys: ['field_4196'],
			key: 'qfauto-37',
			settings: {
				id: 'qfauto-37',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-17': {
			childKeys: [
				'qfauto-19',
				'qfauto-20',
				'qfauto-21',
				'qfauto-22',
				'qfauto-23',
				'qfauto-24',
				'qfauto-25',
				'qfauto-26',
				'qfauto-27',
				'qfauto-28',
				'qfauto-29',
				'qfauto-30',
				'qfauto-31',
				'qfauto-32',
				'qfauto-33',
				'qfauto-34',
				'qfauto-35',
				'qfauto-36',
				'qfauto-37',
			],
			key: 'qfauto-17',
			settings: {
				id: 'qfauto-17',
				label: 'Custom section',
				validation: {},
				FieldSetType: 'customSection',
				icon: 'customSection',
				defaultValue: '',
				className: 'legend-icon-customSection ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_16: {
			childKeys: [],
			key: 'field_16',
			type: 'SelectEmploymentStatusField',
		},
		'qfauto-39': {
			childKeys: ['field_16'],
			key: 'qfauto-39',
			settings: {
				id: 'qfauto-39',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-38': {
			childKeys: ['qfauto-39'],
			key: 'qfauto-38',
			settings: {
				id: 'qfauto-38',
				label: 'Employment Status',
				token: 'tableEmploymentStatus',
				validation: {},
				FieldSetType: 'employmentStatus',
				icon: 'employmentStatus',
				defaultValue: '',
				className: 'legend-icon-employmentStatus ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4022: {
			childKeys: [],
			key: 'field_4022',
			type: 'SelectOvertimeStatusField',
		},
		'field_4237[0]': {
			childKeys: [],
			key: 'field_4237[0]',
			type: 'CurrencyOvertimeRateField',
		},
		'qfauto-41': {
			childKeys: ['field_4022', 'field_4237[0]'],
			key: 'qfauto-41',
			settings: {
				id: 'qfauto-41',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4176: {
			childKeys: [],
			key: 'field_4176',
			type: 'SelectPayScheduleField',
		},
		'qfauto-42': {
			childKeys: ['field_4176'],
			key: 'qfauto-42',
			settings: {
				id: 'qfauto-42',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_156: {
			childKeys: [],
			key: 'field_156',
			type: 'SelectPayTypeField',
		},
		'qfauto-43': {
			childKeys: ['field_156'],
			key: 'qfauto-43',
			settings: {
				id: 'qfauto-43',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'field_19[0]': {
			childKeys: [],
			key: 'field_19[0]',
			type: 'SelectPayRateField',
		},
		'qfauto-44': {
			childKeys: ['field_19[0]'],
			key: 'qfauto-44',
			settings: {
				id: 'qfauto-44',
				label: 'Pay Rate',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-40': {
			childKeys: ['qfauto-41', 'qfauto-42', 'qfauto-43', 'qfauto-44'],
			key: 'qfauto-40',
			settings: {
				id: 'qfauto-40',
				label: 'Compensation',
				token: 'tableCompensation',
				validation: {},
				FieldSetType: 'compensation',
				icon: 'compensation',
				defaultValue: '',
				className: 'legend-icon-compensation ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_17: {
			childKeys: [],
			key: 'field_17',
			type: 'Select',
		},
		field_91: {
			childKeys: [],
			key: 'field_91',
			type: 'Select',
		},
		'qfauto-46': {
			childKeys: ['field_17', 'field_91'],
			key: 'qfauto-46',
			settings: {
				id: 'qfauto-46',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_4: {
			childKeys: [],
			key: 'field_4',
			type: 'Select',
		},
		field_1355: {
			childKeys: [],
			key: 'field_1355',
			type: 'Select',
		},
		'qfauto-47': {
			childKeys: ['field_4', 'field_1355'],
			key: 'qfauto-47',
			settings: {
				id: 'qfauto-47',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		field_18: {
			childKeys: [],
			key: 'field_18',
			type: 'Select',
		},
		'qfauto-48': {
			childKeys: ['field_18'],
			key: 'qfauto-48',
			settings: {
				id: 'qfauto-48',
				validation: {},
				defaultValue: '',
				className: '  ',
				elementSettings: [],
			},
			type: 'Group',
		},
		'qfauto-45': {
			childKeys: ['qfauto-46', 'qfauto-47', 'qfauto-48'],
			key: 'qfauto-45',
			settings: {
				id: 'qfauto-45',
				label: 'Job Information',
				token: 'tableJobInformation',
				validation: {},
				FieldSetType: 'jobInformation',
				icon: 'jobInformation',
				defaultValue: '',
				className: 'legend-icon-jobInformation ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4067: {
			childKeys: [],
			key: 'field_4067',
			type: 'HistoryTableControl',
		},
		'qfauto-49': {
			childKeys: ['field_4067'],
			key: 'qfauto-49',
			settings: {
				id: 'qfauto-49',
				label: 'Bonus',
				token: 'tableBonus',
				validation: {},
				FieldSetType: 'bonus',
				icon: 'bonus',
				defaultValue: '',
				className: 'legend-icon-bonus ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_1028: {
			childKeys: [],
			key: 'field_1028',
			type: 'DirectReports',
		},
		'qfauto-50': {
			childKeys: ['field_1028'],
			key: 'qfauto-50',
			settings: {
				id: 'qfauto-50',
				label: 'Direct Reports',
				token: 'tableDirectReports',
				validation: {},
				FieldSetType: 'directReports',
				icon: 'directReports',
				defaultValue: '',
				className: 'legend-icon-directReports ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4072: {
			childKeys: [],
			key: 'field_4072',
			type: 'HistoryTableControl',
		},
		'qfauto-51': {
			childKeys: ['field_4072'],
			key: 'qfauto-51',
			settings: {
				id: 'qfauto-51',
				label: 'Commission',
				token: 'tableCommission',
				validation: {},
				FieldSetType: 'commission',
				icon: 'commission',
				defaultValue: '',
				className: 'legend-icon-commission ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4221: {
			childKeys: [],
			key: 'field_4221',
			type: 'HistoryTableControl',
		},
		'qfauto-52': {
			childKeys: ['field_4221'],
			key: 'qfauto-52',
			settings: {
				id: 'qfauto-52',
				label: 'Stock Options',
				token: 'tableStockOptions',
				validation: {},
				FieldSetType: 'stockOptions',
				icon: 'stockOptions',
				defaultValue: '',
				className: 'legend-icon-stockOptions ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4064: {
			childKeys: [],
			key: 'field_4064',
			type: 'HistoryTableControl',
		},
		'qfauto-53': {
			childKeys: ['field_4064'],
			key: 'qfauto-53',
			settings: {
				id: 'qfauto-53',
				label: 'Earnings',
				token: 'tableEarnings',
				validation: {},
				FieldSetType: 'earnings',
				icon: 'earnings',
				defaultValue: '',
				className: 'legend-icon-earnings ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4346: {
			childKeys: [],
			key: 'field_4346',
			type: 'HistoryTableControl',
		},
		'qfauto-54': {
			childKeys: ['field_4346'],
			key: 'qfauto-54',
			settings: {
				id: 'qfauto-54',
				label: 'Exposure Tracker',
				token: 'tableExposureTracker',
				validation: {},
				FieldSetType: 'exposureTracker',
				icon: 'exposureTracker',
				defaultValue: '',
				className: 'legend-icon-exposureTracker ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4328: {
			childKeys: [],
			key: 'field_4328',
			type: 'HistoryTableControl',
		},
		'qfauto-55': {
			childKeys: ['field_4328'],
			key: 'qfauto-55',
			settings: {
				id: 'qfauto-55',
				label: 'Testing Tracker',
				token: 'tableTestingTracker',
				validation: {},
				FieldSetType: 'testingTracker',
				icon: 'testingTracker',
				defaultValue: '',
				className: 'legend-icon-testingTracker ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4341: {
			childKeys: [],
			key: 'field_4341',
			type: 'HistoryTableControl',
		},
		'qfauto-56': {
			childKeys: ['field_4341'],
			key: 'qfauto-56',
			settings: {
				id: 'qfauto-56',
				label: 'Vaccination Exemptions',
				token: 'tableVaccinationExemptions',
				validation: {},
				FieldSetType: 'vaccinationExemptions',
				icon: 'vaccinationExemptions',
				defaultValue: '',
				className: 'legend-icon-vaccinationExemptions ',
				elementSettings: [],
			},
			type: 'Section',
		},
		field_4336: {
			childKeys: [],
			key: 'field_4336',
			type: 'HistoryTableControl',
		},
		'qfauto-57': {
			childKeys: ['field_4336'],
			key: 'qfauto-57',
			settings: {
				id: 'qfauto-57',
				label: 'Vaccination History',
				token: 'tableVaccinationHistory',
				validation: {},
				FieldSetType: 'vaccinationHistory',
				icon: 'vaccinationHistory',
				defaultValue: '',
				className: 'legend-icon-vaccinationHistory ',
				elementSettings: [],
			},
			type: 'Section',
		},
		root: {
			childKeys: [
				'_qf__employee',
				'qfauto-1',
				'qfauto-17',
				'qfauto-38',
				'qfauto-40',
				'qfauto-45',
				'qfauto-49',
				'qfauto-50',
				'qfauto-51',
				'qfauto-52',
				'qfauto-53',
				'qfauto-54',
				'qfauto-55',
				'qfauto-56',
				'qfauto-57',
			],
			key: 'root',
			settings: {
				action: '/employees/employee.php?id=40345&page=2060',
				method: 'post',
				id: 'employee',
				validation: {},
				isClickToEdit: true,
				defaultValue: '',
				className: 'BhrForms BhrForms--tight stickyFooter bhrValidate BhrForms--view Quickform ',
				elementSettings: [],
			},
			type: 'Group',
		},
	},
	formElements: [
		{
			id: 'qf:employee',
			name: '_qf__employee',
			'data-lpignore': 'true',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_3',
			id: 'field_3-0',
			'aria-label': 'Hire Date',
			'data-fieldid': '3',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			width: '5',
			'calendar-picker': '',
			'no-facade': '',
			maxLength: '255',
			'data-bi-id': 'quickform-hire-date-field',
			value: '2021-09-20',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Hire Date',
			token: 'textEmployeeHireDate',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'js-validate-hire-date validateHireDate CalendarPicker ',
		},
		{
			name: 'field_1037',
			id: 'field_1037-0',
			'aria-label': 'Ethnicity',
			'data-fieldid': '1037',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			selectedValues: [],
			items: [
				{
					text: 'American Indian or Alaska Native',
					value: '17891',
				},
				{
					text: 'Asian',
					value: '17892',
				},
				{
					text: 'Black or African American',
					value: '17893',
				},
				{
					text: 'Hispanic or Latino',
					value: '17894',
				},
				{
					text: 'Native Hawaiian or Other Pacific Islander',
					value: '17895',
				},
				{
					text: 'Two or More Races',
					value: '17896',
				},
				{
					text: 'White',
					value: '17897',
				},
			],
			'data-lpignore': 'true',
			label: 'Ethnicity',
			token: 'selectEmployeeEthnicity',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_157',
			id: 'field_157-0',
			'aria-label': 'EEO Job Category',
			'data-fieldid': '157',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			selectedValues: [],
			items: [
				{
					text: 'Administrative Support Workers',
					value: '17903',
				},
				{
					text: 'Craft Workers',
					value: '17904',
				},
				{
					text: 'Executive/Senior Level Officials and Managers',
					value: '17898',
				},
				{
					text: 'First/Mid Level Officials and Managers',
					value: '17899',
				},
				{
					text: 'Laborers and Helpers',
					value: '17906',
				},
				{
					text: 'Operatives',
					value: '17905',
				},
				{
					text: 'Professionals',
					value: '17900',
				},
				{
					text: 'Sales Workers',
					value: '17902',
				},
				{
					text: 'Service Workers',
					value: '17907',
				},
				{
					text: 'Technicians',
					value: '17901',
				},
			],
			'data-lpignore': 'true',
			label: 'EEO Job Category',
			token: 'selectEeoCategory',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field  spaced',
		},
		{
			id: 'qfauto-4',
			name: 'field_4001',
			label: 'Veteran Status',
			validation: {},
			defaultValue: '',
			elementSettings: [],
			items: [
				{
					checked: false,
					label: 'Active Duty Wartime or Campaign Badge Veteran',
					value: 17910,
					name: 'field_4001[17910]',
				},
				{
					checked: false,
					label: 'Armed Forces Service Medal Veteran',
					value: 17908,
					name: 'field_4001[17908]',
				},
				{
					checked: false,
					label: 'Disabled Veteran',
					value: 17909,
					name: 'field_4001[17909]',
				},
				{
					checked: false,
					label: 'Recently Separated Veteran',
					value: 17911,
					name: 'field_4001[17911]',
				},
			],
			className: '   ',
		},
		{
			name: 'field_4292[0]',
			id: 'field_4292',
			'aria-label': 'Bonus Currency',
			'data-fieldid': '4292',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '255',
			value: '',
			'data-bi-id': 'quickform-currency-field',
			disabled: false,
			'data-lpignore': 'true',
			currency: {
				code: 'USD',
				symbol: '$',
				symbolPosition: 0,
			},
			label: 'Bonus Currency',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'currency-field  currency-field  ',
		},
		{
			name: 'field_4356',
			id: 'field_4356-0',
			'aria-label': 'Custom address job',
			'data-fieldid': '4356',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'custom',
			placeholder: 'State',
			maxLength: '255',
			selectedValues: [],
			items: [
				{
					text: 'Aberdeen City',
					value: '161',
				},
				{
					text: 'Aberdeenshire',
					value: '160',
				},
				{
					text: 'Angus',
					value: '164',
				},
				{
					text: 'Ards',
					value: '166',
				},
				{
					text: 'Argyll and Bute',
					value: '162',
				},
				{
					text: 'Ballymena',
					value: '177',
				},
				{
					text: 'Ballymoney',
					value: '178',
				},
				{
					text: 'Banbridge',
					value: '180',
				},
				{
					text: 'Barking and Dagenham',
					value: '170',
				},
				{
					text: 'Barnet',
					value: '181',
				},
				{
					text: 'Barnsley',
					value: '183',
				},
				{
					text: 'Bath and North East Somerset',
					value: '168',
				},
				{
					text: 'Bedford',
					value: '115',
				},
				{
					text: 'Belfast',
					value: '173',
				},
				{
					text: 'Berkshire',
					value: '116',
				},
				{
					text: 'Bexley',
					value: '172',
				},
				{
					text: 'Birmingham',
					value: '176',
				},
				{
					text: 'Blackburn with Darwen',
					value: '169',
				},
				{
					text: 'Blackpool',
					value: '185',
				},
				{
					text: 'Blaenau Gwent',
					value: '175',
				},
				{
					text: 'Bolton',
					value: '184',
				},
				{
					text: 'Bournemouth',
					value: '179',
				},
				{
					text: 'Bracknell Forest',
					value: '186',
				},
				{
					text: 'Bradford',
					value: '187',
				},
				{
					text: 'Brent',
					value: '171',
				},
				{
					text: 'Bridgend',
					value: '174',
				},
				{
					text: 'Brighton and Hove',
					value: '182',
				},
				{
					text: 'Bristol, City of',
					value: '189',
				},
				{
					text: 'Bromley',
					value: '188',
				},
				{
					text: 'Buckinghamshire',
					value: '117',
				},
				{
					text: 'Bury',
					value: '190',
				},
				{
					text: 'Caerphilly',
					value: '191',
				},
				{
					text: 'Calderdale',
					value: '198',
				},
				{
					text: 'Cambridgeshire',
					value: '118',
				},
				{
					text: 'Camden',
					value: '201',
				},
				{
					text: 'Cardiff',
					value: '204',
				},
				{
					text: 'Carmarthenshire',
					value: '202',
				},
				{
					text: 'Carrickfergus',
					value: '196',
				},
				{
					text: 'Castlereagh',
					value: '206',
				},
				{
					text: 'Central Bedfordshire',
					value: '192',
				},
				{
					text: 'Ceredigion',
					value: '193',
				},
				{
					text: 'Cheshire',
					value: '119',
				},
				{
					text: 'Cheshire East',
					value: '195',
				},
				{
					text: 'Clackmannanshire',
					value: '199',
				},
				{
					text: 'Coleraine',
					value: '200',
				},
				{
					text: 'Conwy',
					value: '207',
				},
				{
					text: 'Cookstown',
					value: '197',
				},
				{
					text: 'Cornwall',
					value: '120',
				},
				{
					text: 'County Antrim',
					value: '165',
				},
				{
					text: 'County Armagh',
					value: '167',
				},
				{
					text: 'County Down',
					value: '215',
				},
				{
					text: 'County Fermanagh',
					value: '228',
				},
				{
					text: 'County Londonderry',
					value: '367',
				},
				{
					text: 'County Tyrone',
					value: '368',
				},
				{
					text: 'Coventry',
					value: '203',
				},
				{
					text: 'Craigavon',
					value: '194',
				},
				{
					text: 'Croydon',
					value: '205',
				},
				{
					text: 'Cumbria',
					value: '121',
				},
				{
					text: 'Darlington',
					value: '208',
				},
				{
					text: 'Denbighshire',
					value: '209',
				},
				{
					text: 'Derby',
					value: '210',
				},
				{
					text: 'Derbyshire',
					value: '122',
				},
				{
					text: 'Derry',
					value: '216',
				},
				{
					text: 'Devon',
					value: '123',
				},
				{
					text: 'Didcot',
					value: '124',
				},
				{
					text: 'Doncaster',
					value: '213',
				},
				{
					text: 'Dorset',
					value: '125',
				},
				{
					text: 'Dudley',
					value: '217',
				},
				{
					text: 'Dumfries and Galloway',
					value: '212',
				},
				{
					text: 'Dundee City',
					value: '214',
				},
				{
					text: 'Dungannon',
					value: '211',
				},
				{
					text: 'Durham',
					value: '126',
				},
				{
					text: 'Ealing',
					value: '218',
				},
				{
					text: 'East Ayrshire',
					value: '219',
				},
				{
					text: 'East Dunbartonshire',
					value: '221',
				},
				{
					text: 'East Lothian',
					value: '222',
				},
				{
					text: 'East Renfrewshire',
					value: '225',
				},
				{
					text: 'East Riding of Yorkshire',
					value: '226',
				},
				{
					text: 'East Sussex',
					value: '127',
				},
				{
					text: 'Edinburgh, City of',
					value: '220',
				},
				{
					text: 'Eilean Siar',
					value: '223',
				},
				{
					text: 'Enfield',
					value: '224',
				},
				{
					text: 'Essex',
					value: '128',
				},
				{
					text: 'Falkirk',
					value: '227',
				},
				{
					text: 'Fife',
					value: '229',
				},
				{
					text: 'Flintshire',
					value: '230',
				},
				{
					text: 'Gateshead',
					value: '231',
				},
				{
					text: 'Glasgow City',
					value: '232',
				},
				{
					text: 'Gloucestershire',
					value: '129',
				},
				{
					text: 'Greater London',
					value: '369',
				},
				{
					text: 'Greenwich',
					value: '233',
				},
				{
					text: 'Gwynedd',
					value: '234',
				},
				{
					text: 'Hackney',
					value: '237',
				},
				{
					text: 'Halton',
					value: '235',
				},
				{
					text: 'Hammersmith and Fulham',
					value: '240',
				},
				{
					text: 'Hampshire',
					value: '131',
				},
				{
					text: 'Haringey',
					value: '244',
				},
				{
					text: 'Harrow',
					value: '243',
				},
				{
					text: 'Hartlepool',
					value: '242',
				},
				{
					text: 'Havering',
					value: '236',
				},
				{
					text: 'Herefordshire',
					value: '132',
				},
				{
					text: 'Hertfordshire',
					value: '158',
				},
				{
					text: 'Highland',
					value: '239',
				},
				{
					text: 'Hillingdon',
					value: '238',
				},
				{
					text: 'Hounslow',
					value: '241',
				},
				{
					text: 'Inverclyde',
					value: '247',
				},
				{
					text: 'Isle of Anglesey',
					value: '163',
				},
				{
					text: 'Isle of Wight',
					value: '245',
				},
				{
					text: 'Isles of Scilly',
					value: '361',
				},
				{
					text: 'Islington',
					value: '246',
				},
				{
					text: 'Kensington and Chelsea',
					value: '248',
				},
				{
					text: 'Kent',
					value: '133',
				},
				{
					text: 'Kingston upon Hull',
					value: '249',
				},
				{
					text: 'Kingston upon Thames',
					value: '251',
				},
				{
					text: 'Kirklees',
					value: '250',
				},
				{
					text: 'Knowsley',
					value: '252',
				},
				{
					text: 'Lambeth',
					value: '253',
				},
				{
					text: 'Lancashire',
					value: '134',
				},
				{
					text: 'Larne',
					value: '259',
				},
				{
					text: 'Leeds',
					value: '255',
				},
				{
					text: 'Leicester',
					value: '254',
				},
				{
					text: 'Leicestershire',
					value: '135',
				},
				{
					text: 'Leinster',
					value: '136',
				},
				{
					text: 'Lewisham',
					value: '256',
				},
				{
					text: 'Limavady',
					value: '258',
				},
				{
					text: 'Lincolnshire',
					value: '137',
				},
				{
					text: 'Lisburn',
					value: '260',
				},
				{
					text: 'Liverpool',
					value: '257',
				},
				{
					text: 'London, City of',
					value: '130',
				},
				{
					text: 'Luton',
					value: '261',
				},
				{
					text: 'Magherafelt',
					value: '264',
				},
				{
					text: 'Manchester',
					value: '138',
				},
				{
					text: 'Medway',
					value: '263',
				},
				{
					text: 'Merseyside',
					value: '362',
				},
				{
					text: 'Merthyr Tydfil',
					value: '270',
				},
				{
					text: 'Merton',
					value: '268',
				},
				{
					text: 'Middlesbrough',
					value: '262',
				},
				{
					text: 'Middlesex',
					value: '159',
				},
				{
					text: 'Midlothian',
					value: '266',
				},
				{
					text: 'Milton Keynes',
					value: '265',
				},
				{
					text: 'Monmouthshire',
					value: '267',
				},
				{
					text: 'Moray',
					value: '269',
				},
				{
					text: 'Moyle',
					value: '271',
				},
				{
					text: 'Neath Port Talbot',
					value: '281',
				},
				{
					text: 'Newcastle upon Tyne',
					value: '275',
				},
				{
					text: 'Newham',
					value: '283',
				},
				{
					text: 'Newport',
					value: '284',
				},
				{
					text: 'Newry and Mourne',
					value: '286',
				},
				{
					text: 'Newtownabbey',
					value: '280',
				},
				{
					text: 'Norfolk',
					value: '139',
				},
				{
					text: 'North Ayrshire',
					value: '272',
				},
				{
					text: 'North Down',
					value: '273',
				},
				{
					text: 'North East Lincolnshire',
					value: '274',
				},
				{
					text: 'North Lanarkshire',
					value: '277',
				},
				{
					text: 'North Lincolnshire',
					value: '278',
				},
				{
					text: 'North Somerset',
					value: '279',
				},
				{
					text: 'North Tyneside',
					value: '282',
				},
				{
					text: 'North Yorkshire',
					value: '285',
				},
				{
					text: 'Northamptonshire',
					value: '140',
				},
				{
					text: 'Northern Ireland',
					value: '366',
				},
				{
					text: 'Northumberland',
					value: '141',
				},
				{
					text: 'Nottingham',
					value: '276',
				},
				{
					text: 'Nottinghamshire',
					value: '142',
				},
				{
					text: 'Oldham',
					value: '287',
				},
				{
					text: 'Omagh',
					value: '288',
				},
				{
					text: 'Orkney Islands',
					value: '289',
				},
				{
					text: 'Oxfordshire',
					value: '143',
				},
				{
					text: 'Pembrokeshire',
					value: '290',
				},
				{
					text: 'Perth and Kinross',
					value: '291',
				},
				{
					text: 'Peterborough',
					value: '296',
				},
				{
					text: 'Plymouth',
					value: '292',
				},
				{
					text: 'Poole',
					value: '293',
				},
				{
					text: 'Portsmouth',
					value: '294',
				},
				{
					text: 'Powys',
					value: '295',
				},
				{
					text: 'Reading',
					value: '301',
				},
				{
					text: 'Redbridge',
					value: '300',
				},
				{
					text: 'Redcar and Cleveland',
					value: '297',
				},
				{
					text: 'Renfrewshire',
					value: '302',
				},
				{
					text: 'Rhondda, Cynon, Taff',
					value: '299',
				},
				{
					text: 'Richmond upon Thames',
					value: '303',
				},
				{
					text: 'Rochdale',
					value: '298',
				},
				{
					text: 'Rotherham',
					value: '304',
				},
				{
					text: 'Rutland',
					value: '144',
				},
				{
					text: 'Salford',
					value: '313',
				},
				{
					text: 'Sandwell',
					value: '305',
				},
				{
					text: 'Scottish Borders, The',
					value: '307',
				},
				{
					text: 'Sefton',
					value: '308',
				},
				{
					text: 'Sheffield',
					value: '310',
				},
				{
					text: 'Shetland Islands',
					value: '352',
				},
				{
					text: 'Shropshire',
					value: '145',
				},
				{
					text: 'Slough',
					value: '314',
				},
				{
					text: 'Solihull',
					value: '317',
				},
				{
					text: 'Somerset',
					value: '146',
				},
				{
					text: 'South Ayrshire',
					value: '306',
				},
				{
					text: 'South Glamorgan',
					value: '147',
				},
				{
					text: 'South Gloucestershire',
					value: '309',
				},
				{
					text: 'South Lanarkshire',
					value: '315',
				},
				{
					text: 'South Tyneside',
					value: '325',
				},
				{
					text: 'South Yorkshire',
					value: '363',
				},
				{
					text: 'Southampton',
					value: '322',
				},
				{
					text: 'Southend-on-Sea',
					value: '318',
				},
				{
					text: 'Southwark',
					value: '328',
				},
				{
					text: 'St. Helens',
					value: '311',
				},
				{
					text: 'Staffordshire',
					value: '148',
				},
				{
					text: 'Stirling',
					value: '321',
				},
				{
					text: 'Stockport',
					value: '312',
				},
				{
					text: 'Stockton-on-Tees',
					value: '324',
				},
				{
					text: 'Stoke-on-Trent',
					value: '320',
				},
				{
					text: 'Strabane',
					value: '319',
				},
				{
					text: 'Suffolk',
					value: '149',
				},
				{
					text: 'Sunderland',
					value: '316',
				},
				{
					text: 'Surrey',
					value: '150',
				},
				{
					text: 'Sutton',
					value: '323',
				},
				{
					text: 'Swansea',
					value: '326',
				},
				{
					text: 'Swindon',
					value: '327',
				},
				{
					text: 'Tameside',
					value: '329',
				},
				{
					text: 'Telford and Wrekin',
					value: '330',
				},
				{
					text: 'Thurrock',
					value: '331',
				},
				{
					text: 'Torbay',
					value: '332',
				},
				{
					text: 'Torfaen',
					value: '333',
				},
				{
					text: 'Tower Hamlets',
					value: '335',
				},
				{
					text: 'Trafford',
					value: '334',
				},
				{
					text: 'Tyne and Wear',
					value: '365',
				},
				{
					text: 'Vale of Glamorgan, The',
					value: '336',
				},
				{
					text: 'Wakefield',
					value: '341',
				},
				{
					text: 'Walsall',
					value: '342',
				},
				{
					text: 'Waltham Forest',
					value: '339',
				},
				{
					text: 'Wandsworth',
					value: '345',
				},
				{
					text: 'Warrington',
					value: '349',
				},
				{
					text: 'Warwickshire',
					value: '151',
				},
				{
					text: 'West Berkshire',
					value: '337',
				},
				{
					text: 'West Dunbartonshire',
					value: '338',
				},
				{
					text: 'West Lothian',
					value: '343',
				},
				{
					text: 'West Midlands',
					value: '152',
				},
				{
					text: 'West Sussex',
					value: '157',
				},
				{
					text: 'West Yorkshire',
					value: '364',
				},
				{
					text: 'Western Cape',
					value: '153',
				},
				{
					text: 'Westminster',
					value: '351',
				},
				{
					text: 'Wigan',
					value: '340',
				},
				{
					text: 'Wiltshire',
					value: '154',
				},
				{
					text: 'Windsor and Maidenhead',
					value: '346',
				},
				{
					text: 'Wirral',
					value: '348',
				},
				{
					text: 'Wokingham',
					value: '347',
				},
				{
					text: 'Wolverhampton',
					value: '344',
				},
				{
					text: 'Worcestershire',
					value: '155',
				},
				{
					text: 'Wrexham',
					value: '350',
				},
				{
					text: 'York',
					value: '156',
				},
			],
			'data-lpignore': 'true',
			label: 'Custom address job',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'state-field state short custom state-field state short custom ',
		},
		{
			name: 'field_4357',
			id: 'field_4357-0',
			'aria-label': 'custom phone',
			'data-fieldid': '4357',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'custom phone',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: '',
		},
		{
			name: 'field_4358',
			id: 'field_4358-0',
			'aria-label': 'custom percent',
			'data-fieldid': '4358',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'custom percent',
			note: '%',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'validateNumber inline-error validateNumber inline-error ',
		},
		{
			name: 'field_4359',
			id: 'field_4359-0',
			'aria-label': 'Custom number',
			'data-fieldid': '4359',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Custom number',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'validateNumber inline-error validateNumber inline-error ',
		},
		{
			id: 'qfauto-12',
			maxLength: '255',
			name: 'field_4360',
			label: 'Custom multi select',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			elementSettings: [],
			items: [
				{
					checked: false,
					label: 'value 1',
					value: 18056,
					name: 'field_4360[18056]',
				},
				{
					checked: false,
					label: 'value 2',
					value: 18057,
					name: 'field_4360[18057]',
				},
				{
					checked: false,
					label: 'value 3',
					value: 18058,
					name: 'field_4360[18058]',
				},
				{
					checked: false,
					label: 'value 4',
					value: 18059,
					name: 'field_4360[18059]',
				},
				{
					checked: false,
					label: 'value 5',
					value: 18060,
					name: 'field_4360[18060]',
				},
				{
					checked: false,
					label: 'value 6',
					value: 18061,
					name: 'field_4360[18061]',
				},
			],
			className: '   ',
		},
		{
			name: 'field_4361',
			id: 'field_4361-0',
			'aria-label': 'custom text area',
			'data-fieldid': '4361',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '65000',
			value: '',
			'data-lpignore': 'true',
			label: 'custom text area',
			validation: {
				maxLength: 65000,
			},
			defaultValue: '',
			className: '',
		},
		{
			name: 'field_4362',
			id: 'field_4362-0',
			'aria-label': 'custom employee list',
			'data-fieldid': '4362',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'custom',
			maxLength: '255',
			selectedValues: [],
			items: [
				{
					text: '"><<svg onx=() onload=(confirm)(33)> Aran',
					value: '40341',
				},
				{
					text: 'Alois Rangeld',
					value: '8',
				},
				{
					text: 'Anna Strassman',
					value: '13',
				},
				{
					text: 'Bernadetta von Varley',
					value: '40348',
				},
				{
					text: 'Blythe Eisner',
					value: '14',
				},
				{
					text: 'Caspar von Bergliez',
					value: '40349',
				},
				{
					text: 'Catherine Charon',
					value: '10',
				},
				{
					text: 'Cyril><svg onx=() onload=(confirm)("test")> Burns',
					value: '12',
				},
				{
					text: 'Dorothea Arnault',
					value: '40346',
				},
				{
					text: 'Edelgard von Hresvelg',
					value: '40345',
				},
				{
					text: 'Flayn Nabatean',
					value: '17',
				},
				{
					text: 'Gilbert Dominic',
					value: '9',
				},
				{
					text: 'Hanneman von Essar',
					value: '7',
				},
				{
					text: 'Marth Something',
					value: '40342',
				},
				{
					text: 'Petra Macneary',
					value: '40347',
				},
				{
					text: 'Rhea Nabatean',
					value: '15',
				},
				{
					text: 'Seteth Nabatean',
					value: '16',
				},
				{
					text: 'Shamir Nevrand',
					value: '11',
				},
				{
					text: "Stuart M'mm Adams",
					value: '1',
				},
			],
			'data-lpignore': 'true',
			label: 'custom employee list',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'long long ',
		},
		{
			name: 'field_4363[0]',
			id: 'field_4363',
			'aria-label': 'custom currency',
			'data-fieldid': '4363',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'custom',
			maxLength: '255',
			value: '',
			'data-bi-id': 'quickform-currency-field',
			disabled: false,
			'data-lpignore': 'true',
			currency: {
				code: 'USD',
				symbol: '$',
				symbolPosition: 0,
			},
			label: 'custom currency',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'currency-field  currency-field  ',
		},
		{
			name: 'field_1356',
			id: 'field_1356-0',
			'aria-label': 'Department #',
			'data-fieldid': '1356',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '255',
			value: '123545',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Department #',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'text text ',
		},
		{
			name: 'field_4194',
			id: 'field_4194-0',
			'aria-label': 'Probation End Date',
			'data-fieldid': '4194',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			width: '5',
			'calendar-picker': '',
			'no-facade': '',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Probation End Date',
			token: 'textEmployeeProbationEndDate',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'CalendarPicker ',
		},
		{
			name: 'field_4195',
			id: 'field_4195-0',
			'aria-label': 'Contract End Date',
			'data-fieldid': '4195',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			width: '5',
			'calendar-picker': '',
			'no-facade': '',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Contract End Date',
			token: 'textEmployeeContractEndDate',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'CalendarPicker ',
		},
		{
			name: 'field_4201',
			id: 'field_4201-0',
			'aria-label': 'Notice Period',
			'data-fieldid': '4201',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [],
			'data-add-item-field-id': '4201',
			'data-add-item-label': 'Notice Period',
			'data-lpignore': 'true',
			label: 'Notice Period',
			token: 'selectEmployeeNoticePeriod',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_4202',
			id: 'field_4202-0',
			'aria-label': 'Team',
			'data-fieldid': '4202',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [],
			'data-add-item-field-id': '4202',
			'data-add-item-label': 'Team',
			'data-lpignore': 'true',
			label: 'Team',
			token: 'selectEmployeeTeam',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_4077',
			id: 'field_4077-0',
			'aria-label': 'ADP Company Code',
			'data-fieldid': '4077',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [],
			'data-add-item-field-id': '4077',
			'data-add-item-label': 'ADP Company Code',
			'data-lpignore': 'true',
			label: 'ADP Company Code',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_4078',
			id: 'field_4078-0',
			'aria-label': 'ADP File Number',
			'data-fieldid': '4078',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '255',
			value: '123456878453',
			disabled: false,
			'data-lpignore': 'true',
			label: 'ADP File Number',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'text text ',
		},
		{
			name: 'field_4197',
			id: 'field_4197-0',
			'aria-label': 'Citizenship',
			'data-fieldid': '4197',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'standard',
			'data-csz': 'country+citizenship',
			'data-special-csz-labels': 'citizenship',
			selectedValues: [],
			items: [
				{
					text: 'Afghanistan',
					value: '4',
				},
				{
					text: 'Albania',
					value: '5',
				},
				{
					text: 'Algeria',
					value: '6',
				},
				{
					text: 'American Samoa',
					value: '7',
				},
				{
					text: 'Andorra',
					value: '8',
				},
				{
					text: 'Angola',
					value: '10',
				},
				{
					text: 'Anguilla',
					value: '9',
				},
				{
					text: 'Antarctica',
					value: '11',
				},
				{
					text: 'Antigua and Barbuda',
					value: '12',
				},
				{
					text: 'Argentina',
					value: '13',
				},
				{
					text: 'Armenia',
					value: '14',
				},
				{
					text: 'Aruba',
					value: '15',
				},
				{
					text: 'Australia',
					value: '3',
				},
				{
					text: 'Austria',
					value: '16',
				},
				{
					text: 'Azerbaijan',
					value: '17',
				},
				{
					text: 'Åland Islands',
					value: '238',
				},
				{
					text: 'Bahamas',
					value: '18',
				},
				{
					text: 'Bahrain',
					value: '19',
				},
				{
					text: 'Bangladesh',
					value: '20',
				},
				{
					text: 'Barbados',
					value: '21',
				},
				{
					text: 'Belarus',
					value: '241',
				},
				{
					text: 'Belgium',
					value: '22',
				},
				{
					text: 'Belize',
					value: '23',
				},
				{
					text: 'Benin',
					value: '24',
				},
				{
					text: 'Bermuda',
					value: '25',
				},
				{
					text: 'Bhutan',
					value: '26',
				},
				{
					text: 'Bolivia',
					value: '27',
				},
				{
					text: 'Bonaire, Sint Eustatius and Saba',
					value: '240',
				},
				{
					text: 'Bosnia and Herzegovina',
					value: '28',
				},
				{
					text: 'Botswana',
					value: '29',
				},
				{
					text: 'Bouvet Island',
					value: '30',
				},
				{
					text: 'Brazil',
					value: '31',
				},
				{
					text: 'British Indian Ocean Territory',
					value: '32',
				},
				{
					text: 'Brunei Darussalam',
					value: '33',
				},
				{
					text: 'Bulgaria',
					value: '34',
				},
				{
					text: 'Burkina Faso',
					value: '35',
				},
				{
					text: 'Burundi',
					value: '36',
				},
				{
					text: 'Cambodia',
					value: '37',
				},
				{
					text: 'Cameroon',
					value: '38',
				},
				{
					text: 'Canada',
					value: '2',
				},
				{
					text: 'Cape Verde',
					value: '39',
				},
				{
					text: 'Cayman Islands',
					value: '40',
				},
				{
					text: 'Central African Republic',
					value: '41',
				},
				{
					text: 'Chad',
					value: '42',
				},
				{
					text: 'Chile',
					value: '43',
				},
				{
					text: 'China',
					value: '44',
				},
				{
					text: 'Christmas Island',
					value: '45',
				},
				{
					text: 'Cocos (Keeling Islands)',
					value: '46',
				},
				{
					text: 'Colombia',
					value: '47',
				},
				{
					text: 'Comoros',
					value: '48',
				},
				{
					text: 'Congo',
					value: '49',
				},
				{
					text: 'Congo, the Democratic Republic of the',
					value: '242',
				},
				{
					text: 'Cook Islands',
					value: '50',
				},
				{
					text: 'Costa Rica',
					value: '51',
				},
				{
					text: "Cote D'Ivoire (Ivory Coast)",
					value: '52',
				},
				{
					text: 'Croatia (Hrvatska)',
					value: '53',
				},
				{
					text: 'Cuba',
					value: '54',
				},
				{
					text: 'Curaçao',
					value: '243',
				},
				{
					text: 'Cyprus',
					value: '55',
				},
				{
					text: 'Czech Republic',
					value: '56',
				},
				{
					text: 'Denmark',
					value: '57',
				},
				{
					text: 'Djibouti',
					value: '58',
				},
				{
					text: 'Dominica',
					value: '59',
				},
				{
					text: 'Dominican Republic',
					value: '60',
				},
				{
					text: 'East Timor',
					value: '61',
				},
				{
					text: 'Ecuador',
					value: '64',
				},
				{
					text: 'Egypt',
					value: '62',
				},
				{
					text: 'El Salvador',
					value: '63',
				},
				{
					text: 'Equatorial Guinea',
					value: '65',
				},
				{
					text: 'Eritrea',
					value: '66',
				},
				{
					text: 'Estonia',
					value: '67',
				},
				{
					text: 'Ethiopia',
					value: '68',
				},
				{
					text: 'Falkland Islands (Malvinas)',
					value: '69',
				},
				{
					text: 'Faroe Islands',
					value: '70',
				},
				{
					text: 'Fiji',
					value: '71',
				},
				{
					text: 'Finland',
					value: '72',
				},
				{
					text: 'France',
					value: '73',
				},
				{
					text: 'France, Metropolitan',
					value: '74',
				},
				{
					text: 'French Guiana',
					value: '75',
				},
				{
					text: 'French Polynesia',
					value: '76',
				},
				{
					text: 'French Southern Territories',
					value: '77',
				},
				{
					text: 'French West Indies',
					value: '78',
				},
				{
					text: 'Gabon',
					value: '79',
				},
				{
					text: 'Gambia',
					value: '80',
				},
				{
					text: 'Georgia',
					value: '81',
				},
				{
					text: 'Germany',
					value: '82',
				},
				{
					text: 'Ghana',
					value: '83',
				},
				{
					text: 'Gibraltar',
					value: '84',
				},
				{
					text: 'Greece',
					value: '85',
				},
				{
					text: 'Greenland',
					value: '86',
				},
				{
					text: 'Grenada',
					value: '87',
				},
				{
					text: 'Guadeloupe',
					value: '88',
				},
				{
					text: 'Guam',
					value: '89',
				},
				{
					text: 'Guatemala',
					value: '90',
				},
				{
					text: 'Guernsey',
					value: '244',
				},
				{
					text: 'Guinea',
					value: '91',
				},
				{
					text: 'Guinea-Bissau',
					value: '92',
				},
				{
					text: 'Guyana',
					value: '93',
				},
				{
					text: 'Haiti',
					value: '94',
				},
				{
					text: 'Heard and McDonald Islands',
					value: '95',
				},
				{
					text: 'Honduras',
					value: '96',
				},
				{
					text: 'Hong Kong',
					value: '97',
				},
				{
					text: 'Hungary',
					value: '98',
				},
				{
					text: 'Iceland',
					value: '99',
				},
				{
					text: 'India',
					value: '100',
				},
				{
					text: 'Indonesia',
					value: '101',
				},
				{
					text: 'Iran',
					value: '102',
				},
				{
					text: 'Iraq',
					value: '103',
				},
				{
					text: 'Ireland',
					value: '104',
				},
				{
					text: 'Isle of Man',
					value: '246',
				},
				{
					text: 'Israel',
					value: '105',
				},
				{
					text: 'Italy',
					value: '106',
				},
				{
					text: 'Jamaica',
					value: '107',
				},
				{
					text: 'Japan',
					value: '108',
				},
				{
					text: 'Jersey',
					value: '247',
				},
				{
					text: 'Jordan',
					value: '109',
				},
				{
					text: 'Kazakhstan',
					value: '110',
				},
				{
					text: 'Kenya',
					value: '111',
				},
				{
					text: 'Kiribati',
					value: '112',
				},
				{
					text: 'Korea (North)',
					value: '113',
				},
				{
					text: 'Korea (South)',
					value: '114',
				},
				{
					text: 'Kosovo',
					value: '254',
				},
				{
					text: 'Kurdistan',
					value: '255',
				},
				{
					text: 'Kuwait',
					value: '115',
				},
				{
					text: 'Kyrgyzstan',
					value: '116',
				},
				{
					text: 'Laos',
					value: '117',
				},
				{
					text: 'Latvia',
					value: '118',
				},
				{
					text: 'Lebanon',
					value: '119',
				},
				{
					text: 'Lesotho',
					value: '120',
				},
				{
					text: 'Liberia',
					value: '121',
				},
				{
					text: 'Libya',
					value: '122',
				},
				{
					text: 'Liechtenstein',
					value: '123',
				},
				{
					text: 'Lithuania',
					value: '124',
				},
				{
					text: 'Luxembourg',
					value: '125',
				},
				{
					text: 'Macao',
					value: '126',
				},
				{
					text: 'Macedonia',
					value: '127',
				},
				{
					text: 'Madagascar',
					value: '128',
				},
				{
					text: 'Malawi',
					value: '129',
				},
				{
					text: 'Malaysia',
					value: '130',
				},
				{
					text: 'Maldives',
					value: '131',
				},
				{
					text: 'Mali',
					value: '132',
				},
				{
					text: 'Malta',
					value: '133',
				},
				{
					text: 'Marshall Islands',
					value: '134',
				},
				{
					text: 'Martinique',
					value: '135',
				},
				{
					text: 'Mauritania',
					value: '136',
				},
				{
					text: 'Mauritius',
					value: '137',
				},
				{
					text: 'Mayotte',
					value: '138',
				},
				{
					text: 'Mexico',
					value: '139',
				},
				{
					text: 'Micronesia',
					value: '140',
				},
				{
					text: 'Moldova',
					value: '141',
				},
				{
					text: 'Monaco',
					value: '142',
				},
				{
					text: 'Mongolia',
					value: '143',
				},
				{
					text: 'Montenegro',
					value: '144',
				},
				{
					text: 'Montserrat',
					value: '145',
				},
				{
					text: 'Morocco',
					value: '146',
				},
				{
					text: 'Mozambique',
					value: '147',
				},
				{
					text: 'Myanmar',
					value: '248',
				},
				{
					text: 'Namibia',
					value: '148',
				},
				{
					text: 'Nauru',
					value: '149',
				},
				{
					text: 'Nepal',
					value: '150',
				},
				{
					text: 'Netherlands',
					value: '151',
				},
				{
					text: 'Netherlands Antilles',
					value: '152',
				},
				{
					text: 'New Caledonia',
					value: '153',
				},
				{
					text: 'New Zealand',
					value: '154',
				},
				{
					text: 'Nicaragua',
					value: '155',
				},
				{
					text: 'Niger',
					value: '156',
				},
				{
					text: 'Nigeria',
					value: '157',
				},
				{
					text: 'Niue',
					value: '158',
				},
				{
					text: 'Norfolk Island',
					value: '159',
				},
				{
					text: 'Northern Mariana Islands',
					value: '160',
				},
				{
					text: 'Norway',
					value: '161',
				},
				{
					text: 'Oman',
					value: '162',
				},
				{
					text: 'Pakistan',
					value: '163',
				},
				{
					text: 'Palau',
					value: '164',
				},
				{
					text: 'Palestinian Territories',
					value: '249',
				},
				{
					text: 'Panama',
					value: '165',
				},
				{
					text: 'Papua New Guinea',
					value: '166',
				},
				{
					text: 'Paraguay',
					value: '167',
				},
				{
					text: 'Peru',
					value: '168',
				},
				{
					text: 'Philippines',
					value: '169',
				},
				{
					text: 'Pitcairn',
					value: '170',
				},
				{
					text: 'Poland',
					value: '171',
				},
				{
					text: 'Portugal',
					value: '172',
				},
				{
					text: 'Puerto Rico',
					value: '173',
				},
				{
					text: 'Qatar',
					value: '174',
				},
				{
					text: 'Reunion',
					value: '176',
				},
				{
					text: 'Romania',
					value: '177',
				},
				{
					text: 'Russian Federation',
					value: '178',
				},
				{
					text: 'Rwanda',
					value: '175',
				},
				{
					text: 'Saint Barthélemy',
					value: '239',
				},
				{
					text: 'Saint Kitts and Nevis',
					value: '195',
				},
				{
					text: 'Saint Lucia',
					value: '196',
				},
				{
					text: 'Saint Vincent and the Grenadines',
					value: '198',
				},
				{
					text: 'Samoa',
					value: '179',
				},
				{
					text: 'San Marino',
					value: '180',
				},
				{
					text: 'Sao Tome and Principe',
					value: '181',
				},
				{
					text: 'Saudi Arabia',
					value: '182',
				},
				{
					text: 'Senegal',
					value: '183',
				},
				{
					text: 'Serbia',
					value: '184',
				},
				{
					text: 'Seychelles',
					value: '185',
				},
				{
					text: 'Sierra Leone',
					value: '186',
				},
				{
					text: 'Singapore',
					value: '187',
				},
				{
					text: 'Sint Maarten (Dutch part)',
					value: '252',
				},
				{
					text: 'Slovakia',
					value: '188',
				},
				{
					text: 'Slovenia',
					value: '189',
				},
				{
					text: 'Solomon Islands',
					value: '190',
				},
				{
					text: 'Somalia',
					value: '250',
				},
				{
					text: 'South Africa',
					value: '191',
				},
				{
					text: 'South Georgia and the South Sandwich Islands',
					value: '245',
				},
				{
					text: 'South Sudan',
					value: '251',
				},
				{
					text: 'Spain',
					value: '192',
				},
				{
					text: 'Sri Lanka',
					value: '193',
				},
				{
					text: 'St. Helena',
					value: '194',
				},
				{
					text: 'St. Pierre and Miquelon',
					value: '197',
				},
				{
					text: 'Sudan',
					value: '199',
				},
				{
					text: 'Suriname',
					value: '200',
				},
				{
					text: 'Svalbard',
					value: '201',
				},
				{
					text: 'Swaziland',
					value: '202',
				},
				{
					text: 'Sweden',
					value: '203',
				},
				{
					text: 'Switzerland',
					value: '204',
				},
				{
					text: 'Syria',
					value: '205',
				},
				{
					text: 'Taiwan',
					value: '206',
				},
				{
					text: 'Tajikistan',
					value: '207',
				},
				{
					text: 'Tanzania',
					value: '208',
				},
				{
					text: 'Thailand',
					value: '209',
				},
				{
					text: 'Togo',
					value: '210',
				},
				{
					text: 'Tokelau',
					value: '211',
				},
				{
					text: 'Tonga',
					value: '212',
				},
				{
					text: 'Trinidad and Tobago',
					value: '213',
				},
				{
					text: 'Tunisia',
					value: '214',
				},
				{
					text: 'Turkey',
					value: '215',
				},
				{
					text: 'Turkmenistan',
					value: '216',
				},
				{
					text: 'Turks and Caicos Islands',
					value: '217',
				},
				{
					text: 'Tuvalu',
					value: '218',
				},
				{
					text: 'Uganda',
					value: '219',
				},
				{
					text: 'Ukraine',
					value: '220',
				},
				{
					text: 'United Arab Emirates',
					value: '221',
				},
				{
					text: 'United Kingdom',
					value: '222',
				},
				{
					text: 'United States',
					value: '1',
				},
				{
					text: 'Uruguay',
					value: '224',
				},
				{
					text: 'US Minor Outlying Islands',
					value: '223',
				},
				{
					text: 'Uzbekistan',
					value: '225',
				},
				{
					text: 'Vanuatu',
					value: '226',
				},
				{
					text: 'Vatican City State',
					value: '227',
				},
				{
					text: 'Venezuela',
					value: '228',
				},
				{
					text: 'Viet Nam',
					value: '229',
				},
				{
					text: 'Virgin Islands (British)',
					value: '230',
				},
				{
					text: 'Virgin Islands (US)',
					value: '231',
				},
				{
					text: 'Wallis and Futuna Islands',
					value: '232',
				},
				{
					text: 'Western Sahara',
					value: '233',
				},
				{
					text: 'Yemen',
					value: '234',
				},
				{
					text: 'Yugoslavia',
					value: '235',
				},
				{
					text: 'Zaire',
					value: '236',
				},
				{
					text: 'Zambia',
					value: '237',
				},
				{
					text: 'Zimbabwe',
					value: '253',
				},
			],
			'data-lpignore': 'true',
			label: 'Citizenship',
			token: 'selectEmployeeCitizenship',
			validation: {},
			defaultValue: '',
			className: 'xlong xlong  selectField',
		},
		{
			name: 'field_34',
			id: 'field_34-0',
			'aria-label': 'DL #',
			'data-fieldid': '34',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '255',
			'data-employeeid': '40345',
			'data-secure-field-type': 'employeeLicense',
			value: 'XXXXXXXXX',
			disabled: false,
			'data-lpignore': 'true',
			label: 'DL #',
			token: 'textEmployeeLicense',
			validation: {
				maxLength: 255,
			},
			sensitive: {
				value: 'XXX-XXX-XXX',
			},
			defaultValue: '',
			className: 'text text ',
		},
		{
			name: 'field_4093',
			id: 'field_4093-0',
			value: 1,
			'aria-label': 'Sync To ClearBenefits',
			'data-fieldid': '4093',
			'data-type-of-field': 'standard',
			maxLength: '255',
			checked: false,
			'data-lpignore': 'true',
			label: 'Sync To ClearBenefits',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: '   checkbox',
		},
		{
			name: 'field_36',
			id: 'field_36-0',
			'aria-label': 'DL Expiration',
			'data-fieldid': '36',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			width: '5',
			'calendar-picker': '',
			'no-facade': '',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'DL Expiration',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'CalendarPicker ',
		},
		{
			name: 'field_38',
			id: 'field_38-0',
			'aria-label': 'DMV Violations',
			'data-fieldid': '38',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '8',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'DMV Violations',
			validation: {
				maxLength: 8,
			},
			defaultValue: '',
			className: 'validateNumber inline-error text short validateNumber inline-error text short ',
		},
		{
			name: 'field_35',
			id: 'field_35-0',
			'aria-label': 'DL State',
			'data-fieldid': '35',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'standard',
			placeholder: 'State',
			'data-table-name': 'employee_driving_details',
			'data-csz': 'state+employee-driving-details',
			selectedValues: [],
			items: [
				{
					text: 'Aberdeen City',
					value: '161',
				},
				{
					text: 'Aberdeenshire',
					value: '160',
				},
				{
					text: 'Angus',
					value: '164',
				},
				{
					text: 'Ards',
					value: '166',
				},
				{
					text: 'Argyll and Bute',
					value: '162',
				},
				{
					text: 'Ballymena',
					value: '177',
				},
				{
					text: 'Ballymoney',
					value: '178',
				},
				{
					text: 'Banbridge',
					value: '180',
				},
				{
					text: 'Barking and Dagenham',
					value: '170',
				},
				{
					text: 'Barnet',
					value: '181',
				},
				{
					text: 'Barnsley',
					value: '183',
				},
				{
					text: 'Bath and North East Somerset',
					value: '168',
				},
				{
					text: 'Bedford',
					value: '115',
				},
				{
					text: 'Belfast',
					value: '173',
				},
				{
					text: 'Berkshire',
					value: '116',
				},
				{
					text: 'Bexley',
					value: '172',
				},
				{
					text: 'Birmingham',
					value: '176',
				},
				{
					text: 'Blackburn with Darwen',
					value: '169',
				},
				{
					text: 'Blackpool',
					value: '185',
				},
				{
					text: 'Blaenau Gwent',
					value: '175',
				},
				{
					text: 'Bolton',
					value: '184',
				},
				{
					text: 'Bournemouth',
					value: '179',
				},
				{
					text: 'Bracknell Forest',
					value: '186',
				},
				{
					text: 'Bradford',
					value: '187',
				},
				{
					text: 'Brent',
					value: '171',
				},
				{
					text: 'Bridgend',
					value: '174',
				},
				{
					text: 'Brighton and Hove',
					value: '182',
				},
				{
					text: 'Bristol, City of',
					value: '189',
				},
				{
					text: 'Bromley',
					value: '188',
				},
				{
					text: 'Buckinghamshire',
					value: '117',
				},
				{
					text: 'Bury',
					value: '190',
				},
				{
					text: 'Caerphilly',
					value: '191',
				},
				{
					text: 'Calderdale',
					value: '198',
				},
				{
					text: 'Cambridgeshire',
					value: '118',
				},
				{
					text: 'Camden',
					value: '201',
				},
				{
					text: 'Cardiff',
					value: '204',
				},
				{
					text: 'Carmarthenshire',
					value: '202',
				},
				{
					text: 'Carrickfergus',
					value: '196',
				},
				{
					text: 'Castlereagh',
					value: '206',
				},
				{
					text: 'Central Bedfordshire',
					value: '192',
				},
				{
					text: 'Ceredigion',
					value: '193',
				},
				{
					text: 'Cheshire',
					value: '119',
				},
				{
					text: 'Cheshire East',
					value: '195',
				},
				{
					text: 'Clackmannanshire',
					value: '199',
				},
				{
					text: 'Coleraine',
					value: '200',
				},
				{
					text: 'Conwy',
					value: '207',
				},
				{
					text: 'Cookstown',
					value: '197',
				},
				{
					text: 'Cornwall',
					value: '120',
				},
				{
					text: 'County Antrim',
					value: '165',
				},
				{
					text: 'County Armagh',
					value: '167',
				},
				{
					text: 'County Down',
					value: '215',
				},
				{
					text: 'County Fermanagh',
					value: '228',
				},
				{
					text: 'County Londonderry',
					value: '367',
				},
				{
					text: 'County Tyrone',
					value: '368',
				},
				{
					text: 'Coventry',
					value: '203',
				},
				{
					text: 'Craigavon',
					value: '194',
				},
				{
					text: 'Croydon',
					value: '205',
				},
				{
					text: 'Cumbria',
					value: '121',
				},
				{
					text: 'Darlington',
					value: '208',
				},
				{
					text: 'Denbighshire',
					value: '209',
				},
				{
					text: 'Derby',
					value: '210',
				},
				{
					text: 'Derbyshire',
					value: '122',
				},
				{
					text: 'Derry',
					value: '216',
				},
				{
					text: 'Devon',
					value: '123',
				},
				{
					text: 'Didcot',
					value: '124',
				},
				{
					text: 'Doncaster',
					value: '213',
				},
				{
					text: 'Dorset',
					value: '125',
				},
				{
					text: 'Dudley',
					value: '217',
				},
				{
					text: 'Dumfries and Galloway',
					value: '212',
				},
				{
					text: 'Dundee City',
					value: '214',
				},
				{
					text: 'Dungannon',
					value: '211',
				},
				{
					text: 'Durham',
					value: '126',
				},
				{
					text: 'Ealing',
					value: '218',
				},
				{
					text: 'East Ayrshire',
					value: '219',
				},
				{
					text: 'East Dunbartonshire',
					value: '221',
				},
				{
					text: 'East Lothian',
					value: '222',
				},
				{
					text: 'East Renfrewshire',
					value: '225',
				},
				{
					text: 'East Riding of Yorkshire',
					value: '226',
				},
				{
					text: 'East Sussex',
					value: '127',
				},
				{
					text: 'Edinburgh, City of',
					value: '220',
				},
				{
					text: 'Eilean Siar',
					value: '223',
				},
				{
					text: 'Enfield',
					value: '224',
				},
				{
					text: 'Essex',
					value: '128',
				},
				{
					text: 'Falkirk',
					value: '227',
				},
				{
					text: 'Fife',
					value: '229',
				},
				{
					text: 'Flintshire',
					value: '230',
				},
				{
					text: 'Gateshead',
					value: '231',
				},
				{
					text: 'Glasgow City',
					value: '232',
				},
				{
					text: 'Gloucestershire',
					value: '129',
				},
				{
					text: 'Greater London',
					value: '369',
				},
				{
					text: 'Greenwich',
					value: '233',
				},
				{
					text: 'Gwynedd',
					value: '234',
				},
				{
					text: 'Hackney',
					value: '237',
				},
				{
					text: 'Halton',
					value: '235',
				},
				{
					text: 'Hammersmith and Fulham',
					value: '240',
				},
				{
					text: 'Hampshire',
					value: '131',
				},
				{
					text: 'Haringey',
					value: '244',
				},
				{
					text: 'Harrow',
					value: '243',
				},
				{
					text: 'Hartlepool',
					value: '242',
				},
				{
					text: 'Havering',
					value: '236',
				},
				{
					text: 'Herefordshire',
					value: '132',
				},
				{
					text: 'Hertfordshire',
					value: '158',
				},
				{
					text: 'Highland',
					value: '239',
				},
				{
					text: 'Hillingdon',
					value: '238',
				},
				{
					text: 'Hounslow',
					value: '241',
				},
				{
					text: 'Inverclyde',
					value: '247',
				},
				{
					text: 'Isle of Anglesey',
					value: '163',
				},
				{
					text: 'Isle of Wight',
					value: '245',
				},
				{
					text: 'Isles of Scilly',
					value: '361',
				},
				{
					text: 'Islington',
					value: '246',
				},
				{
					text: 'Kensington and Chelsea',
					value: '248',
				},
				{
					text: 'Kent',
					value: '133',
				},
				{
					text: 'Kingston upon Hull',
					value: '249',
				},
				{
					text: 'Kingston upon Thames',
					value: '251',
				},
				{
					text: 'Kirklees',
					value: '250',
				},
				{
					text: 'Knowsley',
					value: '252',
				},
				{
					text: 'Lambeth',
					value: '253',
				},
				{
					text: 'Lancashire',
					value: '134',
				},
				{
					text: 'Larne',
					value: '259',
				},
				{
					text: 'Leeds',
					value: '255',
				},
				{
					text: 'Leicester',
					value: '254',
				},
				{
					text: 'Leicestershire',
					value: '135',
				},
				{
					text: 'Leinster',
					value: '136',
				},
				{
					text: 'Lewisham',
					value: '256',
				},
				{
					text: 'Limavady',
					value: '258',
				},
				{
					text: 'Lincolnshire',
					value: '137',
				},
				{
					text: 'Lisburn',
					value: '260',
				},
				{
					text: 'Liverpool',
					value: '257',
				},
				{
					text: 'London, City of',
					value: '130',
				},
				{
					text: 'Luton',
					value: '261',
				},
				{
					text: 'Magherafelt',
					value: '264',
				},
				{
					text: 'Manchester',
					value: '138',
				},
				{
					text: 'Medway',
					value: '263',
				},
				{
					text: 'Merseyside',
					value: '362',
				},
				{
					text: 'Merthyr Tydfil',
					value: '270',
				},
				{
					text: 'Merton',
					value: '268',
				},
				{
					text: 'Middlesbrough',
					value: '262',
				},
				{
					text: 'Middlesex',
					value: '159',
				},
				{
					text: 'Midlothian',
					value: '266',
				},
				{
					text: 'Milton Keynes',
					value: '265',
				},
				{
					text: 'Monmouthshire',
					value: '267',
				},
				{
					text: 'Moray',
					value: '269',
				},
				{
					text: 'Moyle',
					value: '271',
				},
				{
					text: 'Neath Port Talbot',
					value: '281',
				},
				{
					text: 'Newcastle upon Tyne',
					value: '275',
				},
				{
					text: 'Newham',
					value: '283',
				},
				{
					text: 'Newport',
					value: '284',
				},
				{
					text: 'Newry and Mourne',
					value: '286',
				},
				{
					text: 'Newtownabbey',
					value: '280',
				},
				{
					text: 'Norfolk',
					value: '139',
				},
				{
					text: 'North Ayrshire',
					value: '272',
				},
				{
					text: 'North Down',
					value: '273',
				},
				{
					text: 'North East Lincolnshire',
					value: '274',
				},
				{
					text: 'North Lanarkshire',
					value: '277',
				},
				{
					text: 'North Lincolnshire',
					value: '278',
				},
				{
					text: 'North Somerset',
					value: '279',
				},
				{
					text: 'North Tyneside',
					value: '282',
				},
				{
					text: 'North Yorkshire',
					value: '285',
				},
				{
					text: 'Northamptonshire',
					value: '140',
				},
				{
					text: 'Northern Ireland',
					value: '366',
				},
				{
					text: 'Northumberland',
					value: '141',
				},
				{
					text: 'Nottingham',
					value: '276',
				},
				{
					text: 'Nottinghamshire',
					value: '142',
				},
				{
					text: 'Oldham',
					value: '287',
				},
				{
					text: 'Omagh',
					value: '288',
				},
				{
					text: 'Orkney Islands',
					value: '289',
				},
				{
					text: 'Oxfordshire',
					value: '143',
				},
				{
					text: 'Pembrokeshire',
					value: '290',
				},
				{
					text: 'Perth and Kinross',
					value: '291',
				},
				{
					text: 'Peterborough',
					value: '296',
				},
				{
					text: 'Plymouth',
					value: '292',
				},
				{
					text: 'Poole',
					value: '293',
				},
				{
					text: 'Portsmouth',
					value: '294',
				},
				{
					text: 'Powys',
					value: '295',
				},
				{
					text: 'Reading',
					value: '301',
				},
				{
					text: 'Redbridge',
					value: '300',
				},
				{
					text: 'Redcar and Cleveland',
					value: '297',
				},
				{
					text: 'Renfrewshire',
					value: '302',
				},
				{
					text: 'Rhondda, Cynon, Taff',
					value: '299',
				},
				{
					text: 'Richmond upon Thames',
					value: '303',
				},
				{
					text: 'Rochdale',
					value: '298',
				},
				{
					text: 'Rotherham',
					value: '304',
				},
				{
					text: 'Rutland',
					value: '144',
				},
				{
					text: 'Salford',
					value: '313',
				},
				{
					text: 'Sandwell',
					value: '305',
				},
				{
					text: 'Scottish Borders, The',
					value: '307',
				},
				{
					text: 'Sefton',
					value: '308',
				},
				{
					text: 'Sheffield',
					value: '310',
				},
				{
					text: 'Shetland Islands',
					value: '352',
				},
				{
					text: 'Shropshire',
					value: '145',
				},
				{
					text: 'Slough',
					value: '314',
				},
				{
					text: 'Solihull',
					value: '317',
				},
				{
					text: 'Somerset',
					value: '146',
				},
				{
					text: 'South Ayrshire',
					value: '306',
				},
				{
					text: 'South Glamorgan',
					value: '147',
				},
				{
					text: 'South Gloucestershire',
					value: '309',
				},
				{
					text: 'South Lanarkshire',
					value: '315',
				},
				{
					text: 'South Tyneside',
					value: '325',
				},
				{
					text: 'South Yorkshire',
					value: '363',
				},
				{
					text: 'Southampton',
					value: '322',
				},
				{
					text: 'Southend-on-Sea',
					value: '318',
				},
				{
					text: 'Southwark',
					value: '328',
				},
				{
					text: 'St. Helens',
					value: '311',
				},
				{
					text: 'Staffordshire',
					value: '148',
				},
				{
					text: 'Stirling',
					value: '321',
				},
				{
					text: 'Stockport',
					value: '312',
				},
				{
					text: 'Stockton-on-Tees',
					value: '324',
				},
				{
					text: 'Stoke-on-Trent',
					value: '320',
				},
				{
					text: 'Strabane',
					value: '319',
				},
				{
					text: 'Suffolk',
					value: '149',
				},
				{
					text: 'Sunderland',
					value: '316',
				},
				{
					text: 'Surrey',
					value: '150',
				},
				{
					text: 'Sutton',
					value: '323',
				},
				{
					text: 'Swansea',
					value: '326',
				},
				{
					text: 'Swindon',
					value: '327',
				},
				{
					text: 'Tameside',
					value: '329',
				},
				{
					text: 'Telford and Wrekin',
					value: '330',
				},
				{
					text: 'Thurrock',
					value: '331',
				},
				{
					text: 'Torbay',
					value: '332',
				},
				{
					text: 'Torfaen',
					value: '333',
				},
				{
					text: 'Tower Hamlets',
					value: '335',
				},
				{
					text: 'Trafford',
					value: '334',
				},
				{
					text: 'Tyne and Wear',
					value: '365',
				},
				{
					text: 'Vale of Glamorgan, The',
					value: '336',
				},
				{
					text: 'Wakefield',
					value: '341',
				},
				{
					text: 'Walsall',
					value: '342',
				},
				{
					text: 'Waltham Forest',
					value: '339',
				},
				{
					text: 'Wandsworth',
					value: '345',
				},
				{
					text: 'Warrington',
					value: '349',
				},
				{
					text: 'Warwickshire',
					value: '151',
				},
				{
					text: 'West Berkshire',
					value: '337',
				},
				{
					text: 'West Dunbartonshire',
					value: '338',
				},
				{
					text: 'West Lothian',
					value: '343',
				},
				{
					text: 'West Midlands',
					value: '152',
				},
				{
					text: 'West Sussex',
					value: '157',
				},
				{
					text: 'West Yorkshire',
					value: '364',
				},
				{
					text: 'Western Cape',
					value: '153',
				},
				{
					text: 'Westminster',
					value: '351',
				},
				{
					text: 'Wigan',
					value: '340',
				},
				{
					text: 'Wiltshire',
					value: '154',
				},
				{
					text: 'Windsor and Maidenhead',
					value: '346',
				},
				{
					text: 'Wirral',
					value: '348',
				},
				{
					text: 'Wokingham',
					value: '347',
				},
				{
					text: 'Wolverhampton',
					value: '344',
				},
				{
					text: 'Worcestershire',
					value: '155',
				},
				{
					text: 'Wrexham',
					value: '350',
				},
				{
					text: 'York',
					value: '156',
				},
			],
			'data-lpignore': 'true',
			label: 'DL State',
			validation: {},
			defaultValue: '',
			className: 'state-field state short state-field state short  selectField',
		},
		{
			name: 'field_37',
			id: 'field_37-0',
			'aria-label': 'Driver Classification',
			'data-fieldid': '37',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [
				{
					text: 'Cannot transport clients',
					value: '17890',
				},
				{
					text: 'Company and personal',
					value: '17888',
				},
				{
					text: 'Company only',
					value: '17889',
				},
			],
			'data-add-item-field-id': '37',
			'data-add-item-label': 'Driver Classification',
			'data-lpignore': 'true',
			label: 'Driver Classification',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_4289',
			id: 'field_4289-0',
			value: 1,
			'aria-label': 'State UI Tax Exempt',
			'data-fieldid': '4289',
			'data-type-of-field': 'standard',
			maxLength: '255',
			checked: false,
			'data-lpignore': 'true',
			label: 'State UI Tax Exempt',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: '   checkbox',
		},
		{
			name: 'field_4180',
			id: 'field_4180-0',
			'aria-label': 'Nationality',
			'data-fieldid': '4180',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [],
			'data-add-item-field-id': '4180',
			'data-add-item-label': 'Nationality',
			'data-lpignore': 'true',
			label: 'Nationality',
			token: 'selectEmployeeNationality',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_4079',
			id: 'field_4079-0',
			'aria-label': 'Standard Hours Per Week',
			'data-fieldid': '4079',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '255',
			value: '',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Standard Hours Per Week',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'validateNumber inline-error validateNumber inline-error ',
		},
		{
			name: 'field_4196',
			id: 'field_4196-0',
			'aria-label': 'Tax File Number',
			'data-fieldid': '4196',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			maxLength: '255',
			value: '12354231213521',
			disabled: false,
			'data-lpignore': 'true',
			label: 'Tax File Number',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: '',
		},
		{
			width: '7',
			'custom-modal-key': 'employmentStatus',
			name: 'field_16',
			id: 'field_16-0',
			'aria-label': 'Employment Status',
			'data-fieldid': '16',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: ['17974'],
			items: [
				{
					text: 'Active',
					value: '17973',
				},
				{
					text: 'Contractor',
					value: '17874',
				},
				{
					text: 'Full-Time',
					value: '17872',
				},
				{
					text: 'Furloughed',
					value: '17956',
					props: {
						'data-inactiveoption': true,
					},
				},
				{
					text: 'Inactive',
					value: '17974',
				},
				{
					text: 'Not Employed',
					value: '18066',
				},
				{
					text: 'Parental Leave',
					value: '18054',
				},
				{
					text: 'Part-Time',
					value: '17873',
				},
				{
					text: 'Terminated',
					value: '17875',
					props: {
						'data-terminatedoption': true,
					},
				},
			],
			'data-add-item-field-id': '16',
			'data-add-item-label': 'Employment Status',
			'data-custom-modal-key': 'employmentStatus',
			'data-lpignore': 'true',
			label: 'Employment Status',
			token: 'selectEmployeeEmploymentStatus',
			acaStatuses: [
				'contractor',
				'full-time',
				'intern-compensated',
				'intern-not-compensated',
				'part-time-eligible',
				'part-time-ineligible',
				'seasonal',
			],
			showAcaStatus: true,
			validation: {},
			defaultValue: '',
			className: 'js-employmentStatusSelect list-field employment-status-field list-field ',
		},
		{
			name: 'field_4022',
			id: 'field_4022-0',
			'aria-label': 'Overtime Status',
			'data-fieldid': '4022',
			autoComplete: 'disable-auto-complete',
			width: '6',
			'data-type-of-field': 'standard',
			maxLength: '255',
			selectedValues: ['Exempt'],
			items: [
				{
					text: 'Exempt',
					value: 'Exempt',
				},
				{
					text: 'Non-exempt',
					value: 'Non-exempt',
				},
			],
			'data-lpignore': 'true',
			label: 'Overtime Status',
			token: 'selectEmployeePayExempt',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'js-exemptStatus overtime-status-field ',
		},
		{
			name: 'field_4237[0]',
			id: 'field_4237',
			'aria-label': 'Overtime Rate',
			'data-fieldid': '4237',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			value: '',
			'data-bi-id': 'quickform-currency-field',
			disabled: false,
			'data-lpignore': 'true',
			currency: {
				code: 'USD',
				symbol: '$',
				symbolPosition: 0,
			},
			label: 'Overtime Rate',
			token: 'currencyOvertimeRate',
			validation: {},
			defaultValue: '',
			className: 'currency-field  js-overtimeRate currency-field  validateOvertimeRateTrax overtime-rate-field  spaced',
		},
		{
			name: 'field_4176',
			id: 'field_4176-0',
			'aria-label': 'Pay Schedule',
			'data-fieldid': '4176',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			selectedValues: ['17943'],
			items: [
				{
					text: 'Bi-Monthly',
					value: '17943',
				},
			],
			'data-lpignore': 'true',
			label: 'Pay Schedule',
			token: 'selectEmployeePaySchedule',
			validation: {},
			defaultValue: '',
			className: 'list-field js-pay-schedule-insertable-list js-paySchedule list-field pay-schedule-field ',
		},
		{
			name: 'field_156',
			id: 'field_156-0',
			'aria-label': 'Pay type',
			'data-fieldid': '156',
			autoComplete: 'disable-auto-complete',
			width: '6',
			'data-type-of-field': 'standard',
			maxLength: '255',
			selectedValues: ['Salary'],
			items: [
				{
					text: 'Salary',
					value: 'Salary',
					props: {
						'data-invalid-payroll-option': false,
					},
				},
				{
					text: 'Hourly',
					value: 'Hourly',
					props: {
						'data-invalid-payroll-option': false,
					},
				},
				{
					text: 'Commission Only',
					value: 'Commission',
					props: {
						'data-invalid-payroll-option': false,
					},
				},
				{
					text: 'Contract',
					value: 'Contract',
					props: {
						'data-invalid-payroll-option': true,
					},
				},
			],
			'data-lpignore': 'true',
			label: 'Pay type',
			token: 'selectEmployeeCompType',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'js-payType pay-type-field ',
		},
		{
			name: 'field_19[0]',
			id: 'field_19',
			'aria-label': 'Pay rate',
			'data-fieldid': '19',
			autoComplete: 'disable-auto-complete',
			'data-type-of-field': 'standard',
			value: '$254,00 USD',
			'data-bi-id': 'quickform-currency-field',
			disabled: false,
			'data-lpignore': 'true',
			currency: {
				code: 'USD',
				symbol: '$',
				symbolPosition: 0,
			},
			token: 'currencyEmployeeCompRate',
			validation: {},
			defaultValue: '',
			className: 'currency-field js-rate inline-error currency-field pay-rate-field inline-error ',
		},
		{
			name: 'field_17',
			id: 'field_17-0',
			'aria-label': 'Job Title',
			'data-fieldid': '17',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			selectedValues: [],
			items: [
				{
					text: 'Archer',
					value: '18012',
				},
				{
					text: 'Celeric',
					value: '18064',
				},
				{
					text: 'Flame Emperor',
					value: '17959',
				},
				{
					text: 'Guardsmen',
					value: '17962',
				},
				{
					text: 'Heavy Cavalier',
					value: '18019',
				},
				{
					text: 'Laborer',
					value: '17960',
				},
				{
					text: 'Mage',
					value: '17976',
				},
				{
					text: 'Mortal Savant',
					value: '18063',
				},
				{
					text: 'Paladin',
					value: '18062',
				},
				{
					text: "This is a really long job title and I'm curious to see how this will display in the org chart now",
					value: '18011',
				},
			],
			'data-add-item-field-id': '17',
			'data-add-item-label': 'Job Title',
			'data-lpignore': 'true',
			label: 'Job Title',
			token: 'selectEmployeeJobTitle',
			validation: {},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_91',
			id: 'field_91-0',
			'aria-label': 'Reporting to',
			'data-fieldid': '91',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'standard',
			maxLength: '255',
			selectedValues: ['10'],
			items: [
				{
					text: '"><<svg onx=() onload=(confirm)(33)> Aran',
					value: '40341',
				},
				{
					text: 'Alois Rangeld',
					value: '8',
				},
				{
					text: 'Anna Strassman',
					value: '13',
				},
				{
					text: 'Bernadetta von Varley',
					value: '40348',
				},
				{
					text: 'Blythe Eisner',
					value: '14',
				},
				{
					text: 'Caspar von Bergliez',
					value: '40349',
				},
				{
					text: 'Catherine Charon',
					value: '10',
				},
				{
					text: 'Cyril><svg onx=() onload=(confirm)("test")> Burns',
					value: '12',
				},
				{
					text: 'Dorothea Arnault',
					value: '40346',
				},
				{
					text: 'Edelgard von Hresvelg',
					value: '40345',
				},
				{
					text: 'Flayn Nabatean',
					value: '17',
				},
				{
					text: 'Gilbert Dominic',
					value: '9',
				},
				{
					text: 'Hanneman von Essar',
					value: '7',
				},
				{
					text: 'Marth Something',
					value: '40342',
				},
				{
					text: 'Petra Macneary',
					value: '40347',
				},
				{
					text: 'Rhea Nabatean',
					value: '15',
				},
				{
					text: 'Seteth Nabatean',
					value: '16',
				},
				{
					text: 'Shamir Nevrand',
					value: '11',
				},
				{
					text: "Stuart M'mm Adams",
					value: '1',
				},
			],
			'data-lpignore': 'true',
			label: 'Reporting to',
			token: 'selectEmployeeJobReportsTo',
			validation: {
				maxLength: 255,
			},
			defaultValue: '',
			className: 'long long  spaced',
		},
		{
			name: 'field_4',
			id: 'field_4-0',
			'aria-label': 'Department',
			'data-fieldid': '4',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			maxLength: '255',
			'can-add': '1',
			selectedValues: [],
			items: [
				{
					text: 'Adrestian Officers',
					value: '17965',
				},
				{
					text: 'Black Eagles',
					value: '17977',
				},
				{
					text: 'Church Guards',
					value: '17963',
				},
				{
					text: 'Faerghus Officers',
					value: '17966',
				},
				{
					text: 'Leicester Officers',
					value: '17967',
				},
				{
					text: 'The Eagle & The Lion',
					value: '17978',
				},
			],
			'data-add-item-field-id': '4',
			'data-add-item-label': 'Department',
			'data-lpignore': 'true',
			label: 'Department',
			token: 'selectEmployeeJobDepartment',
			validation: {
				maxLength: 255,
				maxLengthTrax: 100,
			},
			defaultValue: '',
			className: 'list-field list-field ',
		},
		{
			name: 'field_1355',
			id: 'field_1355-0',
			'aria-label': 'Division',
			'data-fieldid': '1355',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			maxLength: '255',
			'can-add': '1',
			selectedValues: [],
			items: [
				{
					text: 'Alliance',
					value: '17970',
				},
				{
					text: 'Church of Seiros',
					value: '17964',
				},
				{
					text: 'Empire',
					value: '17968',
				},
				{
					text: 'Holy Kingdom',
					value: '17969',
				},
			],
			'data-add-item-field-id': '1355',
			'data-add-item-label': 'Division',
			'data-lpignore': 'true',
			label: 'Division',
			token: 'selectEmployeeJobDivision',
			validation: {
				maxLength: 255,
				maxLengthTrax: 100,
			},
			defaultValue: '',
			className: 'list-field list-field  spaced',
		},
		{
			name: 'field_18',
			id: 'field_18-0',
			'aria-label': 'Location',
			autoComplete: 'disable-auto-complete',
			width: '7',
			'data-type-of-field': 'list',
			'can-add': '1',
			'data-add-item-label': 'Location',
			maxLength: '255',
			selectedValues: [],
			items: [
				{
					text: 'Adrestian Empire2',
					value: '17957',
				},
				{
					text: 'Garreg Mach Monastery',
					value: '17972',
				},
				{
					text: 'Holy Kingdom of Faerghus',
					value: '17958',
				},
				{
					text: 'Leicester Alliance',
					value: '17971',
				},
			],
			'data-add-item-field-id': null,
			'data-lpignore': 'true',
			label: 'Location',
			token: 'selectEmployeeJobLocation',
			validation: {
				maxLength: 255,
				maxLengthTrax: 50,
			},
			defaultValue: '',
			className: 'list-field js-location-insertable-list list-field js-location-insertable-list ',
		},
		{
			name: 'field_4067',
			id: 'field_4067-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/bonus/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tUpdate Bonus\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Amount</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Reason</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comment</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-bonus BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-ymd tableDate ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-amount  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-reasonId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comment  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="bonus"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'bonus\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="5">\r\n\t\t\t\tNo bonus entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Bonus',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_1028',
			id: 'field_1028-0',
			componentHtml:
				'<div class="fieldRow"><div class="fieldBox DirectReports"><label class="fab-Label DirectReports__label">Direct Reports</label><div class="fieldDiv"><ul><li><a href="/employees/employee.php?id=40348">Bernadetta von Varley</a></li><li><a href="/employees/employee.php?id=40349">Caspar von Bergliez</a></li><li><a href="/employees/employee.php?id=40346">Dorothea Arnault</a></li><li><a href="/employees/employee.php?id=40347">Petra Macneary</a></li></ul></div></div></div>',
			componentJson: {
				40346: 'Dorothea Arnault',
				40347: 'Petra Macneary',
				40348: 'Bernadetta von Varley',
				40349: 'Caspar von Bergliez',
			},
			'data-lpignore': 'true',
			label: 'Direct Reports',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4072',
			id: 'field_4072-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/commission/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tUpdate Commission\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Amount</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comment</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-commission BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-ymd tableDate ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-amount  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comment  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="commission"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'commission\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="4">\r\n\t\t\t\tNo commission entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Commission',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4221',
			id: 'field_4221-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/employee_stock_options/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tAdd Stock Options\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Grant Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div># Options Granted</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Option Price</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Vesting Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Plan</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comments</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-employee_stock_options BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-grantDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-numberOptionsGranted  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-optionPrice  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-vestingDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-planId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comments  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="employee_stock_options"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'employee_stock_options\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="7">\r\n\t\t\t\tNo stock options entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Stock Options',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4064',
			id: 'field_4064-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/earnings/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tUpdate Earnings\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Prior Year W2/K1</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-earnings BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-ymd tableDate ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-priorYear  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="earnings"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'earnings\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="3">\r\n\t\t\t\tNo earnings entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Earnings',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4346',
			id: 'field_4346-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/employee_covid_exposures/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tAdd Exposure Tracker\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Exposure Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Vaccination Status</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Notified</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comments</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-employee_covid_exposures BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-exposureDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-vaccinationStatusId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-notified  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comments  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="employee_covid_exposures"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'employee_covid_exposures\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="5">\r\n\t\t\t\tNo exposure tracker entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Exposure Tracker',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4328',
			id: 'field_4328-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/employee_covid_tests/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tAdd Testing Tracker\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Test Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Results</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Test Type</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Testing Reason</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Confirmed by HR</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Office Eligibility</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comments</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-employee_covid_tests BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-testDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-resultsId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-testTypeId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-testingReasonId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-confirmedByHr  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-officeEligibility  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comments  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="employee_covid_tests"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'employee_covid_tests\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="8">\r\n\t\t\t\tNo testing tracker entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Testing Tracker',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4341',
			id: 'field_4341-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/employee_covid_vaccination_exemptions/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tAdd Vaccination Exemptions\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Exemption Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Exemption Reason</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Exemption Documentation Collected</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Comments</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-employee_covid_vaccination_exemptions BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-exemptionDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-exemptionReasonId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-exemptionDocumentationCollected  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-comments  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="employee_covid_vaccination_exemptions"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'employee_covid_vaccination_exemptions\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="5">\r\n\t\t\t\tNo vaccination exemptions entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Vaccination Exemptions',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_4336',
			id: 'field_4336-0',
			template: 'blank_template.html.twig',
			componentHtml:
				'\t\t\t\t\t<div class="Quickform__tableActions">\t\t\t\t<a\n\t\t\t\t\thref="javascript:void(0);"\n\t\t\t\t\turl="/ajax/dialog/history_popup/employee_covid_vaccinations/40345"\n\t\t\t\t\t\t\t\t\t\tdata-modal-size="small"\n\t\t\t\t\tclass="fab-TextButton fab-link history-modal js-updateBhrTable"\n\t\t\t\t>\t\t\t\t\t\t<span class="fab-TextButton__icon fab-TextButton__icon--left">\n\t\t\t\t\t\t\t<ba-icon name="fab-circle-plus-14x14"></ba-icon>\n\t\t\t\t\t\t</span>\n\t\t\t\t\tAdd Vaccination History\t\t\t\t</a>\n\t\t\t</div>\t\t<div class="BhrTable__scrollWrapper js-BhrTable-scroll">\r\n\t\t<div class="BhrTable__scrollWrapper-inner">\r\n\t\t<table class="BhrTable fab-Table fab-Table--hoverable BhrTable BhrTable--history fab-Table fab-Table--history" >\r\n\t\t<thead class="BhrTable__head">\r\n\t\t<tr class="BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Vaccination Status</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Administration Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Vaccine Received</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Dosage</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Verified</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Date Verified</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header "\r\n\t\t\t\t\tstyle="width: inherit">\r\n\t\t\t\t\t<div>Office Eligible Date</div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th class="BhrTable__head fab-Table__header" style="width: 60px;">\r\n\t\t\t\t\t<div></div>\r\n\t\t\t\t</th>\r\n\t\t\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody class="history-table type-employee_covid_vaccinations BhrTable__body">\r\n\t\t<tr style="display:none" class="template BhrTable__row fab-Table__row">\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-vaccinationStatusId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-administrationDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-vaccineReceivedId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-dosageId  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-verified  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-dateVerified  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t<td class="BhrTable__cell fab-Table__cell field-officeEligibleDate  ">\r\n\t\t\t\t\t<p class="js-historyCellWrapper"></p></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="fab-Table__cell fab-Table__cell--alignRight">\r\n\t\t\t\t\t\t\t\t<span class="BhrTable__actions fab-Table__cellMask fab-ButtonGroup">\r\n\t\t\t\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t\t\t\t\tclass="history-modal fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-modal-size="medium"\r\n\t\t\t\t\t\t\t\t\t\t\turl="employee_covid_vaccinations"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon class="fab-FloatingIconButton__icon"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="fab-pencil-16x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fab-FloatingIconButton fab-FloatingIconButton--secondary fab-FloatingIconButton--teenie"\r\n\t\t\t\t\t\t\t\t\t\t\tonclick="return BambooHR.HistoryTable.deleteRow($(this),\'employee_covid_vaccinations\')"\r\n\t\t\t\t\t\t\t\t\t\t\ttype="button"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fab-FloatingIconButton__icon">\r\n\t\t\t\t\t\t\t\t\t\t\t<ba-icon name="fab-trash-can-14x16"></ba-icon>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr class="BhrTable__row empty fab-Table__row fab-Table__row--empty">\r\n\t\t\t<td class="BhrTable__cell fab-Table__cell" colspan="8">\r\n\t\t\t\tNo vaccination history entries have been added.\t\t\t</td>\r\n\t\t</tr>\r\n\r\n\t\t\t\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t',
			componentJson: [],
			'data-lpignore': 'true',
			label: 'Vaccination History',
			validation: {},
			defaultValue: '',
			className: '  ',
		},
	],
	customRendererNeededFormLayoutKeys: ['qfauto-18'],
	elementMetaSettings: {
		'qf:employee': [],
		'field_3-0': {
			isCustomField: false,
			initialValue: '2021-09-20',
		},
		'field_1037-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_157-0': {
			isCustomField: false,
			initialValue: [],
		},
		field_4292: {
			isCustomField: true,
			initialValue: '',
		},
		'field_4356-0': {
			isCustomField: true,
			initialValue: [],
		},
		'field_4357-0': {
			isCustomField: true,
			initialValue: '',
		},
		'field_4358-0': {
			isCustomField: true,
			initialValue: '',
		},
		'field_4359-0': {
			isCustomField: true,
			initialValue: '',
		},
		'field_4361-0': {
			isCustomField: true,
			initialValue: '',
		},
		'field_4362-0': {
			isCustomField: true,
			initialValue: [],
		},
		field_4363: {
			isCustomField: true,
			initialValue: '',
		},
		'field_1356-0': {
			isCustomField: false,
			initialValue: '123545',
		},
		'field_4194-0': {
			isCustomField: false,
			initialValue: '',
		},
		'field_4195-0': {
			isCustomField: false,
			initialValue: '',
		},
		'field_4201-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4202-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4077-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4078-0': {
			isCustomField: false,
			initialValue: '123456878453',
		},
		'field_4197-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_34-0': {
			isCustomField: false,
			initialValue: 'XXXXXXXXX',
		},
		'field_4093-0': {
			isCustomField: false,
			initialValue: false,
		},
		'field_36-0': {
			isCustomField: false,
			initialValue: '',
		},
		'field_38-0': {
			isCustomField: false,
			initialValue: '',
		},
		'field_35-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_37-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4289-0': {
			isCustomField: false,
			initialValue: false,
		},
		'field_4180-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4079-0': {
			isCustomField: false,
			initialValue: '',
		},
		'field_4196-0': {
			isCustomField: false,
			initialValue: '12354231213521',
		},
		'field_16-0': {
			isCustomField: false,
			initialValue: ['17974'],
		},
		'field_4022-0': {
			isCustomField: false,
			initialValue: ['Exempt'],
		},
		field_4237: {
			isCustomField: false,
			initialValue: '',
		},
		'field_4176-0': {
			isCustomField: false,
			initialValue: ['17943'],
		},
		'field_156-0': {
			isCustomField: false,
			initialValue: ['Salary'],
		},
		field_19: {
			isCustomField: false,
			initialValue: '$254,00 USD',
		},
		'field_17-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_91-0': {
			isCustomField: false,
			initialValue: ['10'],
		},
		'field_4-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_1355-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_18-0': {
			isCustomField: false,
			initialValue: [],
		},
		'field_4067-0': [],
		'field_1028-0': [],
		'field_4072-0': [],
		'field_4221-0': [],
		'field_4064-0': [],
		'field_4346-0': [],
		'field_4328-0': [],
		'field_4341-0': [],
		'field_4336-0': [],
	},
	tokenMetadata: {
		tableJobInformation: {
			date: '2022-04-05',
		},
		tableCompensation: {
			date: '2022-04-05',
		},
		tableEmployeeStatus: {
			date: '2022-04-05',
		},
		selectEmployeeEmploymentStatus: {
			hireDate: '2021-02-03',
			statusRowId: '27075',
		},
	},
};

export const updatedJobTabTableData = {
	layout: {
		_qf__employee: {
			childKeys: [],
			key: '_qf__employee',
			type: 'HiddenInput',
		},
		field_1620: {
			childKeys: [],
			key: 'field_1620',
			type: 'HistoryTableControl',
			settings: {
				name: 'field_1620',
				id: 'field_1620-0',
				template: 'blank_template.html.twig',
				componentJson: {
					rows: [
						{
							displayType: 'future',
							fields: [
								{
									id: 1936,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2024-03-01',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 16,
									name: 'Employment Status',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '18054',
											label: 'Parental Leave',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4027,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 27088,
						},
						{
							displayType: 'current',
							fields: [
								{
									id: 1936,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-04-05',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 16,
									name: 'Employment Status',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17974',
											label: 'Inactive',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4027,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 27090,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 1936,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-03-17',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 16,
									name: 'Employment Status',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17974',
											label: 'Inactive',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4027,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 27089,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 1936,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-02-02',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 16,
									name: 'Employment Status',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17973',
											label: 'Active',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4027,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 27084,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 1936,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2021-02-03',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 16,
									name: 'Employment Status',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17973',
											label: 'Active',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4027,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 27075,
						},
					],
					canEdit: true,
					canDeleteRows: true,
					headerNames: ['Effective Date', 'Employment Status', 'Comment'],
					tableType: 'status',
				},
				'data-lpignore': 'true',
				label: 'Employment Status',
				token: 'tableEmploymentStatus',
				validation: null,
				defaultValue: '',
				className: '  ',
				elementSettings: {
					validation: {},
				},
			},
		},
		'qfauto-1': {
			childKeys: ['field_1620'],
			key: 'qfauto-1',
			settings: {
				id: 'qfauto-1',
				label: 'Employment Status',
				FieldSetType: 'employmentStatus',
				icon: 'employmentStatus',
				validation: null,
				defaultValue: '',
				className: 'legend-icon-employmentStatus ',
				elementSettings: {
					validation: {},
				},
			},
			type: 'Section',
		},
		field_1027: {
			childKeys: [],
			key: 'field_1027',
			type: 'HistoryTableControl',
			settings: {
				name: 'field_1027',
				id: 'field_1027-0',
				template: 'blank_template.html.twig',
				componentJson: {
					rows: [
						{
							displayType: 'future',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2023-01-27',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: 'Salary',
											label: 'Salary',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: 'Exempt',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17342,
						},
						{
							displayType: 'current',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-04-05',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: 'Salary',
											label: 'Salary',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: {
											amount: '254.00',
											code: 'USD',
										},
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: 'Exempt',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17346,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-03-17',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: 'Salary',
											label: 'Salary',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: {
											amount: '254.00',
											code: 'USD',
										},
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: 'Exempt',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17345,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-03-01',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: 'Salary',
											label: 'Salary',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: {
											amount: '254.00',
											code: 'USD',
										},
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: 'Exempt',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17343,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2021-02-03',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: null,
											label: null,
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: [],
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17336,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4029,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2020-03-01',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4176,
									name: 'Pay Schedule',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Bi-Monthly',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 156,
									name: 'Pay Type',
									permissions: 'edit',
									content: {
										type: 'pay_type',
										value: {
											id: 'Hourly',
											label: 'Hourly',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 19,
									name: 'Pay Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: {
											amount: '20.00',
											code: 'USD',
										},
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4165,
									name: 'Paid Per',
									permissions: 'edit',
									content: {
										type: 'text',
										value: 'Hour',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4022,
									name: 'Overtime',
									permissions: 'edit',
									content: {
										type: 'exempt',
										value: 'Non-exempt',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4237,
									name: 'Overtime Rate',
									permissions: 'edit',
									content: {
										type: 'currency',
										value: {
											amount: '30.00',
											code: 'USD',
										},
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 4017,
									name: 'Change Reason',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4026,
									name: 'Comment',
									permissions: 'edit',
									content: {
										type: 'text',
										value: null,
										pending: false,
										displayType: 'text',
									},
								},
							],
							id: 17344,
						},
					],
					canEdit: true,
					canDeleteRows: true,
					headerNames: [
						'Effective Date',
						'Pay Schedule',
						'Pay Type',
						'Pay Rate',
						'Paid Per',
						'Overtime',
						'Overtime Rate',
						'Change Reason',
						'Comment',
					],
					tableType: 'compensation',
				},
				'data-lpignore': 'true',
				label: 'Compensation',
				token: 'tableCompensation',
				validation: null,
				defaultValue: '',
				className: '  ',
				elementSettings: {
					validation: {},
				},
			},
		},
		'qfauto-2': {
			childKeys: ['field_1027'],
			key: 'qfauto-2',
			settings: {
				id: 'qfauto-2',
				label: 'Compensation',
				FieldSetType: 'compensation',
				icon: 'compensation',
				validation: null,
				defaultValue: '',
				className: 'legend-icon-compensation ',
				elementSettings: {
					validation: {},
				},
			},
			type: 'Section',
		},
		field_1619: {
			childKeys: [],
			key: 'field_1619',
			type: 'HistoryTableControl',
			settings: {
				name: 'field_1619',
				id: 'field_1619-0',
				template: 'blank_template.html.twig',
				componentJson: {
					rows: [
						{
							displayType: 'future',
							fields: [
								{
									id: 4028,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2023-01-02',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 18,
									name: 'Location',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17957',
											label: 'Adrestian Empire2',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 1355,
									name: 'Division',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17970',
											label: 'Alliance',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4,
									name: 'Department',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17965',
											label: 'Adrestian Officers',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 17,
									name: 'Job Title',
									permissions: 'edit',
									content: {
										type: 'list',
										value: {
											id: '17959',
											label: 'Flame Emperor',
										},
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 91,
									name: 'Reports To',
									permissions: 'edit',
									content: {
										type: 'employee',
										value: {
											id: '10',
											name: 'Catherine Charon',
										},
										pending: false,
										displayType: 'list',
									},
								},
							],
							id: 38155,
						},
						{
							displayType: 'current',
							fields: [
								{
									id: 4028,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-04-05',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 18,
									name: 'Location',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 1355,
									name: 'Division',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4,
									name: 'Department',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 17,
									name: 'Job Title',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 91,
									name: 'Reports To',
									permissions: 'edit',
									content: {
										type: 'employee',
										value: {
											id: '10',
											name: 'Catherine Charon',
										},
										pending: false,
										displayType: 'list',
									},
								},
							],
							id: 38169,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4028,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2022-03-17',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 18,
									name: 'Location',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 1355,
									name: 'Division',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4,
									name: 'Department',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 17,
									name: 'Job Title',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 91,
									name: 'Reports To',
									permissions: 'edit',
									content: {
										type: 'employee',
										value: {
											id: '10',
											name: 'Catherine Charon',
										},
										pending: false,
										displayType: 'list',
									},
								},
							],
							id: 38168,
						},
						{
							displayType: 'past',
							fields: [
								{
									id: 4028,
									name: 'Effective Date',
									permissions: 'edit',
									content: {
										type: 'date',
										value: '2021-08-02',
										pending: false,
										displayType: 'text',
									},
								},
								{
									id: 18,
									name: 'Location',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 1355,
									name: 'Division',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 4,
									name: 'Department',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 17,
									name: 'Job Title',
									permissions: 'edit',
									content: {
										type: 'list',
										value: [],
										pending: false,
										displayType: 'list',
									},
								},
								{
									id: 91,
									name: 'Reports To',
									permissions: 'edit',
									content: {
										type: 'employee',
										value: {
											id: '10',
											name: 'Catherine Charon',
										},
										pending: false,
										displayType: 'list',
									},
								},
							],
							id: 38162,
						},
					],
					canEdit: true,
					canDeleteRows: true,
					headerNames: ['Effective Date', 'Location', 'Division', 'Department', 'Job Title', 'Reports To'],
					tableType: 'job',
				},
				'data-lpignore': 'true',
				label: 'Job Information',
				token: 'tableJobInformation',
				validation: null,
				defaultValue: '',
				className: '  ',
				elementSettings: {
					validation: {},
				},
			},
		},
		'qfauto-3': {
			childKeys: ['field_1619'],
			key: 'qfauto-3',
			settings: {
				id: 'qfauto-3',
				label: 'Job Information',
				FieldSetType: 'jobInformation',
				icon: 'jobInformation',
				validation: null,
				defaultValue: '',
				className: 'legend-icon-jobInformation ',
				elementSettings: {
					validation: {},
				},
			},
			type: 'Section',
		},
		field_1028: {
			childKeys: [],
			key: 'field_1028',
			type: 'DirectReports',
		},
		'qfauto-4': {
			childKeys: ['field_1028'],
			key: 'qfauto-4',
			settings: {
				id: 'qfauto-4',
				label: 'Direct Reports',
				FieldSetType: 'directReports',
				icon: 'directReports',
				validation: null,
				defaultValue: '',
				className: 'legend-icon-directReports ',
				elementSettings: {
					validation: {},
				},
			},
			type: 'Section',
		},
		root: {
			childKeys: ['_qf__employee', 'qfauto-1', 'qfauto-2', 'qfauto-3', 'qfauto-4'],
			key: 'root',
			settings: {
				action: '/employees/employee.php?id=40345&page=2060',
				method: 'post',
				id: 'employee',
				isClickToEdit: true,
				validation: null,
				defaultValue: '',
				className: 'BhrForms BhrForms--tight stickyFooter bhrValidate BhrForms--view Quickform ',
				elementSettings: {
					validation: {},
				},
			},
			type: 'Group',
		},
	},
	formElements: [
		{
			id: 'qf:employee',
			name: '_qf__employee',
			'data-lpignore': 'true',
			validation: null,
			defaultValue: '',
			className: '  ',
		},
		{
			name: 'field_1028',
			id: 'field_1028-0',
			componentJson: {
				40346: 'Dorothea Arnault',
				40347: 'Petra Macneary',
				40348: 'Bernadetta von Varley',
				40349: 'Caspar von Bergliez',
			},
			'data-lpignore': 'true',
			label: 'Direct Reports',
			token: 'tableDirectReports',
			validation: null,
			defaultValue: '',
			className: '  ',
		},
	],
	customRendererNeededFormLayoutKeys: ['field_1620', 'field_1027', 'field_1619'],
	idsByToken: {
		tableDirectReports: 'field_1028-0',
	},
	metadataById: {
		'qf:employee': {
			validation: {},
		},
		'field_1028-0': {
			validation: {},
		},
	},
};
